<template>
  <div class="employee-page wage-hr-page">
    <div class="employee-layout">
      <aside class="emp-sidebar member-remote-sidebar">
        <div class="sidebar-scroll">
          <div class="sidebar-top">
            <!-- 사원 탭 리모컨 -->
            <template v-if="activeTab === 'employee'">
              <div class="sidebar-filter-card">
                <div class="group-label">현황 필터</div>
                <div class="filter-tabs">
                  <button type="button" class="filter-tab" :class="{ active: employeeStatusFilter === '' }" @click="employeeStatusFilter = ''">전체</button>
                  <button type="button" class="filter-tab" :class="{ active: employeeStatusFilter === '현원' }" @click="employeeStatusFilter = '현원'">현원</button>
                  <button type="button" class="filter-tab" :class="{ active: employeeStatusFilter === '퇴사' }" @click="employeeStatusFilter = '퇴사'">퇴사</button>
                  <button
                    type="button"
                    class="filter-tab filter-tab--ssn"
                    :class="{ active: employeeStatusFilter === '주민번호미등록' }"
                    @click="employeeStatusFilter = '주민번호미등록'"
                  >주민번호 미등록</button>
                  <button
                    type="button"
                    class="filter-tab filter-tab--app"
                    :class="{ active: employeeStatusFilter === '앱연동' }"
                    @click="employeeStatusFilter = '앱연동'"
                  >앱연동</button>
                </div>
              </div>
              <div v-if="employeeMeta.lastAutoCollectWdate" class="sidebar-auto-collect">
                <v-icon size="13" color="#64748b">mdi-cloud-download-outline</v-icon>
                <span>자동수집 {{ formatDateTime(employeeMeta.lastAutoCollectWdate) }}</span>
              </div>
              <div class="sidebar-summary">
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot total"></span>
                    <span class="label">전체</span>
                  </div>
                  <span class="value">{{ employeeStats.total }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot active"></span>
                    <span class="label">현원</span>
                  </div>
                  <span class="value highlight">{{ employeeStats.hyunwon }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot inactive"></span>
                    <span class="label">퇴사</span>
                  </div>
                  <span class="value">{{ employeeStats.toesaw }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot ssn-missing"></span>
                    <span class="label">주민번호 미등록</span>
                  </div>
                  <span class="value" :class="{ warn: employeeSsnMissingCount > 0 }">{{ employeeSsnMissingCount }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot app-link"></span>
                    <span class="label">앱연동</span>
                  </div>
                  <span class="value">{{ employeeAppLinkedCount }}명</span>
                </div>
                <div class="summary-item summary-item--sub">
                  <span class="label-sub">당월입사 {{ employeeStats.monthEnter }} · 당월퇴사 {{ employeeStats.monthLeave }}</span>
                </div>
              </div>
              <div class="sidebar-search-filters">
                <span class="search-label">사원 검색</span>
                <div class="search-input-wrapper">
                  <input v-model="employeeSearchText" type="text" placeholder="이름 검색..." class="search-input" />
                  <button v-if="employeeSearchText" type="button" class="search-clear" @click="employeeSearchText = ''">
                    <v-icon size="10">mdi-close</v-icon>
                  </button>
                </div>
              </div>
            </template>

            <!-- 수급자 탭 리모컨 -->
            <template v-else>
              <div class="sidebar-filter-card">
                <div class="group-label">현황 필터</div>
                <div class="filter-tabs">
                  <button type="button" class="filter-tab" :class="{ active: beneficiaryStatusFilter === '' }" @click="beneficiaryStatusFilter = ''">전체</button>
                  <button type="button" class="filter-tab" :class="{ active: beneficiaryStatusFilter === '입소' }" @click="beneficiaryStatusFilter = '입소'">입소</button>
                  <button type="button" class="filter-tab" :class="{ active: beneficiaryStatusFilter === '퇴소' }" @click="beneficiaryStatusFilter = '퇴소'">퇴소</button>
                </div>
              </div>
              <div v-if="beneficiaryMeta.lastAutoCollectWdate" class="sidebar-auto-collect">
                <v-icon size="13" color="#64748b">mdi-cloud-download-outline</v-icon>
                <span>자동수집 {{ formatDateTime(beneficiaryMeta.lastAutoCollectWdate) }}</span>
              </div>
              <div class="sidebar-summary">
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot total"></span>
                    <span class="label">전체</span>
                  </div>
                  <span class="value">{{ beneficiaryStats.total }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot active"></span>
                    <span class="label">입소</span>
                  </div>
                  <span class="value highlight">{{ beneficiaryStats.ipso }}명</span>
                </div>
                <div class="summary-item">
                  <div class="summary-header">
                    <span class="dot inactive"></span>
                    <span class="label">퇴소</span>
                  </div>
                  <span class="value">{{ beneficiaryStats.toiso }}명</span>
                </div>
                <div class="summary-item summary-item--sub">
                  <span class="label-sub">당월입소 {{ beneficiaryStats.monthEnter }} · 당월퇴소 {{ beneficiaryStats.monthLeave }}</span>
                </div>
              </div>
              <div class="sidebar-search-filters">
                <span class="search-label">수급자 검색</span>
                <div class="search-input-wrapper">
                  <input v-model="beneficiarySearchText" type="text" placeholder="이름, 인정번호..." class="search-input" />
                  <button v-if="beneficiarySearchText" type="button" class="search-clear" @click="beneficiarySearchText = ''">
                    <v-icon size="10">mdi-close</v-icon>
                  </button>
                </div>
              </div>
            </template>
          </div>

          <LtcsRequestSidebarButton
            :member-code="memberCode"
            :biz-gubun="selectedBizGubun"
            :year-month="scheduleYearMonth"
            variant="hr"
            @ready="loadAll"
          />
        </div>
      </aside>

      <div class="emp-main">
        <div class="wage-hr-toolbar">
          <div class="wage-hr-segment" role="tablist" aria-label="인사관리 목록 구분">
            <button
              type="button"
              role="tab"
              class="wage-hr-segment-btn wage-hr-segment-btn--employee"
              :class="{ active: activeTab === 'employee' }"
              :aria-selected="activeTab === 'employee'"
              @click="setActiveTab('employee')"
            >
              <span class="segment-icon">
                <v-icon size="20">mdi-account-hard-hat</v-icon>
              </span>
              <span class="segment-text">
                <span class="segment-label">사원</span>
                <span class="segment-desc">종사자 · 직원</span>
              </span>
              <span class="segment-count">{{ employeeStats.total }}</span>
            </button>
            <button
              type="button"
              role="tab"
              class="wage-hr-segment-btn wage-hr-segment-btn--beneficiary"
              :class="{ active: activeTab === 'beneficiary' }"
              :aria-selected="activeTab === 'beneficiary'"
              @click="setActiveTab('beneficiary')"
            >
              <span class="segment-icon">
                <v-icon size="20">mdi-wheelchair-accessibility</v-icon>
              </span>
              <span class="segment-text">
                <span class="segment-label">수급자</span>
                <span class="segment-desc">이용자 · 대상자</span>
              </span>
              <span class="segment-count">{{ beneficiaryStats.total }}</span>
            </button>
          </div>
          <div class="wage-hr-toolbar-actions">
            <button
              v-if="activeTab === 'employee'"
              type="button"
              class="ben-quickadd-toggle"
              :class="{ active: showEmployeeQuickAdd }"
              @click="showEmployeeQuickAdd = !showEmployeeQuickAdd"
            >
              <v-icon size="15">{{ showEmployeeQuickAdd ? 'mdi-chevron-up' : 'mdi-account-plus-outline' }}</v-icon>
              간편등록
            </button>
            <button
              v-if="activeTab === 'beneficiary'"
              type="button"
              class="ben-quickadd-toggle"
              :class="{ active: showBeneficiaryQuickAdd }"
              @click="showBeneficiaryQuickAdd = !showBeneficiaryQuickAdd"
            >
              <v-icon size="15">{{ showBeneficiaryQuickAdd ? 'mdi-chevron-up' : 'mdi-account-plus-outline' }}</v-icon>
              간편등록
            </button>
            <button
              v-if="activeTab === 'beneficiary'"
              type="button"
              class="ben-excel-btn"
              @click="openBeneficiaryExcelModal"
            >
              <v-icon size="15">mdi-file-excel-outline</v-icon>
              엑셀 업로드
            </button>
            <template v-if="activeTab === 'beneficiary'">
              <button type="button" class="hr-toolbar-schedule-btn" @click="showAllBeneficiarySchedule = true">
                <v-icon size="15">mdi-calendar-month</v-icon>
                전체 일정
              </button>
              <button
                type="button"
                class="hr-toolbar-schedule-btn hr-toolbar-schedule-btn--pdf"
                :disabled="beneficiaryPdfLoading"
                @click="downloadAllBeneficiaryPdf"
              >
                <v-icon size="15">{{ beneficiaryPdfLoading ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box' }}</v-icon>
                전체 PDF
              </button>
            </template>
            <template v-if="activeTab === 'employee'">
              <button
                type="button"
                class="hr-toolbar-schedule-btn hr-toolbar-schedule-btn--pdf"
                :disabled="employeePdfLoading"
                @click="downloadAllCaregiverPdf"
              >
                <v-icon size="15">{{ employeePdfLoading ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box' }}</v-icon>
                전체 PDF
              </button>
            </template>
          </div>
        </div>

        <!-- 사원목록 탭 -->
        <div v-show="activeTab === 'employee'" class="wage-hr-tab-panel">
          <div class="wage-hr-tab-panel-body">
            <div class="hr-app-link-guide">
              <v-icon size="16" color="#1e3a5f">mdi-cellphone-link</v-icon>
              <div class="hr-app-link-guide__body">
                <p class="hr-app-link-guide__title">카이온 앱 요양보호사 연결</p>
                <p class="hr-app-link-guide__text">
                  요양보호사 앱 계정은 여기서 만들지 않습니다. 성명·휴대폰을 사원으로 등록한 뒤,
                  같은 휴대폰으로 앱에 가입하면 연결됩니다. 앱에 이름이 없으면 동기화할 때 웹 사원 이름이 들어갑니다.
                  가입 후에도 센터 앱에 안 보이면 센터 앱 인사관리에서 「동기화」를 누르세요.
                  연동된 사원은 이름 옆에 「앱연동」이 표시됩니다.
                </p>
              </div>
            </div>
            <div
              v-if="employeeSsnMissingCount > 0 && employeeStatusFilter !== '주민번호미등록'"
              class="hr-ssn-guide"
            >
              <v-icon size="16" color="#e65100">mdi-card-account-details-outline</v-icon>
              <div class="hr-ssn-guide__body">
                <p class="hr-ssn-guide__title">주민번호가 없는 직원이 {{ employeeSsnMissingCount }}명 있어요</p>
                <p class="hr-ssn-guide__text">
                  자동수집 직원은 주민번호가 비어 있을 수 있습니다.
                  임금·4대보험 계산을 위해 상세에서 주민번호 뒷자리를 등록해 주세요.
                </p>
              </div>
              <button type="button" class="hr-ssn-guide__btn" @click="employeeStatusFilter = '주민번호미등록'">
                미등록 목록 보기
              </button>
            </div>

            <transition name="panel-slide">
              <div v-if="showEmployeeQuickAdd" class="ben-quickadd-panel ben-quickadd-panel--employee">
                <div
                  v-for="(row, rowIdx) in newEmployeeRows"
                  :key="row._key"
                  class="quickadd-row"
                >
                  <div class="quickadd-fields quickadd-fields--employee">
                    <div class="qf-item qf-name">
                      <label v-if="rowIdx === 0">성명 <em>*</em></label>
                      <input v-model="row.clci_name" placeholder="성명" />
                    </div>
                    <div class="qf-item qf-birth">
                      <label v-if="rowIdx === 0">생년월일(8자리) <em>*</em></label>
                      <input
                        :value="row.clci_birth_ymd"
                        maxlength="8"
                        inputmode="numeric"
                        placeholder="YYYYMMDD"
                        autocomplete="off"
                        @input="onEmployeeBirthYmdInput(row, $event)"
                      />
                    </div>
                    <div class="qf-item qf-ssn">
                      <label v-if="rowIdx === 0">주민뒷자리 <em>*</em></label>
                      <input
                        v-model="row.clci_ssn_back"
                        maxlength="7"
                        inputmode="numeric"
                        placeholder="7자리"
                        autocomplete="off"
                      />
                    </div>
                    <div class="qf-item qf-job">
                      <label v-if="rowIdx === 0">직종 <em>*</em></label>
                      <select v-model="row.clci_job_type">
                        <option value="">선택</option>
                        <option v-for="pos in positionOptions" :key="pos" :value="pos">{{ pos }}</option>
                      </select>
                    </div>
                    <div class="qf-item qf-phone">
                      <label v-if="rowIdx === 0">휴대폰 <em>*</em></label>
                      <input v-model="row.clci_phone" placeholder="010-0000-0000" />
                    </div>
                    <div class="qf-item qf-email">
                      <label v-if="rowIdx === 0">이메일</label>
                      <input v-model="row.clci_email" type="email" placeholder="선택" />
                    </div>
                    <div class="qf-item qf-date">
                      <label v-if="rowIdx === 0">입사일 <em>*</em></label>
                      <YmdDateInput v-model="row.clci_work_start_date" />
                    </div>
                    <div class="qf-item qf-row-actions">
                      <label v-if="rowIdx === 0">&nbsp;</label>
                      <div class="qf-row-btns">
                        <button
                          v-if="rowIdx === newEmployeeRows.length - 1"
                          type="button"
                          class="qf-icon-btn qf-icon-btn--add"
                          title="행 추가"
                          @click="addEmployeeQuickRow"
                        >
                          <v-icon size="16">mdi-plus</v-icon>
                        </button>
                        <button
                          v-if="newEmployeeRows.length > 1"
                          type="button"
                          class="qf-icon-btn qf-icon-btn--remove"
                          title="행 삭제"
                          @click="removeEmployeeQuickRow(rowIdx)"
                        >
                          <v-icon size="16">mdi-minus</v-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="quickadd-footer">
                  <span class="quickadd-footer-hint">{{ newEmployeeRows.length }}명 · + 로 추가</span>
                  <button
                    type="button"
                    class="qf-register-btn"
                    @click="saveNewEmployee"
                    :disabled="employeeSaving || !employeeQuickAddJoinReady"
                    :title="employeeQuickAddJoinReady ? '' : '입사일을 입력해야 등록할 수 있습니다.'"
                  >
                    <v-progress-circular v-if="employeeSaving" indeterminate size="14" width="2" color="white" />
                    <template v-else>일괄 등록</template>
                  </button>
                </div>
              </div>
            </transition>

          <div class="emp-table-wrap">
            <table class="emp-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_name')">
                    성명 <v-icon size="14">{{ getEmployeeSortIcon('clci_name') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_job_type')">
                    직종 <v-icon size="14">{{ getEmployeeSortIcon('clci_job_type') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_age')">
                    만나이 <v-icon size="14">{{ getEmployeeSortIcon('clci_age') }}</v-icon>
                  </th>
                  <th>주민등록번호</th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_work_start_date')">
                    입사일 <v-icon size="14">{{ getEmployeeSortIcon('clci_work_start_date') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_work_end_date')">
                    퇴사일 <v-icon size="14">{{ getEmployeeSortIcon('clci_work_end_date') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('month_status')">
                    현황 <v-icon size="14">{{ getEmployeeSortIcon('month_status') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_source_label')">
                    수집구분 <v-icon size="14">{{ getEmployeeSortIcon('clci_source_label') }}</v-icon>
                  </th>
                  <th class="sortable" @click="toggleEmployeeSort('clci_wdate')">
                    수집일시 <v-icon size="14">{{ getEmployeeSortIcon('clci_wdate') }}</v-icon>
                  </th>
                  <th class="col-schedule">일정</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="employeeLoading">
                  <td colspan="11" class="empty-row">
                    <v-progress-circular indeterminate color="primary" size="32" />
                  </td>
                </tr>
                <tr v-else-if="filteredEmployeeList.length === 0">
                  <td colspan="11" class="empty-row">
                    <template v-if="employeeStatusFilter === '앱연동'">앱과 연동된 사원이 없습니다.</template>
                    <template v-else>
                      해당 연월에 표시할 사원이 없습니다.
                      <button v-if="!showEmployeeQuickAdd" type="button" class="hr-empty-add-btn" @click="showEmployeeQuickAdd = true">간편등록</button>
                    </template>
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="(item, idx) in filteredEmployeeList"
                  :key="item.person_key || `${item.clci_source}-${item.clci_idx}`"
                  class="row-clickable"
                  :class="{ 'row-duplicate': item.is_duplicate }"
                  @click="openEmployeeDetail(item)"
                >
                  <td>{{ idx + 1 }}</td>
                  <td class="td-name">
                    <div class="name-cell">
                      <div class="avatar" :style="{ background: getAvatarColor(item.clci_name) }">
                        {{ getInitial(item.clci_name) }}
                      </div>
                      <span class="name-with-app">
                        <span>{{ item.clci_name }}</span>
                        <span
                          v-if="isEmployeeAppLinked(item)"
                          class="app-link-badge"
                          :title="employeeAppLinkTitle(item)"
                        >앱연동</span>
                      </span>
                      <span
                        v-if="isEmployeeSsnMissing(item)"
                        class="ssn-missing-badge"
                        title="상세에서 주민번호 뒷자리를 등록해 주세요"
                      >미등록</span>
                      <span v-if="item.is_rehire || isEmployeeRehire(item)" class="month-badge enter">재입사</span>
                      <span v-if="item.is_month_enter" class="month-badge enter">당월입사</span>
                      <span v-if="item.is_month_leave" class="month-badge leave">당월퇴사</span>
                    </div>
                  </td>
                  <td>{{ item.clci_job_type || '-' }}</td>
                  <td>{{ item.clci_age != null ? `${item.clci_age}세` : '-' }}</td>
                  <td class="td-ssn">
                    <template v-if="formatSsnFront(item.clci_birth_date) !== '******'">
                      <span class="emp-ssn-line">{{ formatSsnFront(item.clci_birth_date) }}-</span>
                      <span
                        class="emp-ssn-line"
                        :class="isEmployeeSsnMissing(item) ? 'emp-ssn-line--missing' : 'emp-ssn-line--mask'"
                      >{{ isEmployeeSsnMissing(item) ? '미등록' : '*******' }}</span>
                    </template>
                    <template v-else>-</template>
                  </td>
                  <td class="td-join" :title="joinDateHint(item)">
                    <div class="emp-join">
                      <span class="emp-join__main">{{ formatDate(shownEmployment(item)?.clci_work_start_date) }}</span>
                      <span
                        v-for="line in otherJoinLines(item)"
                        :key="`${line.clci_source}-${line.clci_idx}-start`"
                        class="emp-join__sub"
                      >{{ otherJoinCaption(item, line) }}</span>
                    </div>
                  </td>
                  <td>
                    {{ formatDate(shownEmployment(item)?.clci_work_end_date) }}
                  </td>
                  <td>
                    <span class="status-chip" :class="item.month_status === '현원' ? 'active' : 'inactive'">
                      {{ item.month_status }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="source-chip"
                      :class="shownEmployment(item)?.clci_source === 'manual' ? 'manual' : 'auto'"
                    >{{ employmentSourceLabel(shownEmployment(item)?.clci_source) }}</span>
                  </td>
                  <td>{{ formatDateTime(latestCollectAt(item)) }}</td>
                  <td class="col-schedule">
                    <button
                      type="button"
                      class="hr-schedule-btn"
                      :disabled="!canOpenEmployeeSchedule(item)"
                      :title="canOpenEmployeeSchedule(item) ? '월간 일정 보기' : '생년월일이 있어야 일정을 조회할 수 있습니다'"
                      @click.stop="openEmployeeSchedule(item)"
                    >
                      <v-icon size="16">mdi-calendar-clock</v-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        </div>

        <!-- 수급자목록 탭 -->
        <div v-show="activeTab === 'beneficiary'" class="wage-hr-tab-panel">
          <div class="wage-hr-tab-panel-body">
            <transition name="panel-slide">
              <div v-if="showBeneficiaryQuickAdd" class="ben-quickadd-panel">
                <div class="quickadd-fields">
                  <div class="qf-item">
                    <label>수급자명 <em>*</em></label>
                    <input v-model="newBeneficiaryForm.clsr_recipient_name" placeholder="수급자명" />
                  </div>
                  <div class="qf-item">
                    <label>인정번호</label>
                    <input
                      :value="newBeneficiaryForm.clsr_approval_no || ''"
                      placeholder="L0000000000"
                      maxlength="11"
                      @focus="onRecipientIdFocus"
                      @blur="onRecipientIdBlur"
                      @input="onRecipientIdInput"
                      :class="{ 'input-error': newBeneficiaryForm.clsr_approval_no && !isValidRecipientId(newBeneficiaryForm.clsr_approval_no) }"
                    />
                  </div>
                  <div class="qf-item">
                    <label>생년월일 <em>*</em></label>
                    <YmdDateInput v-model="newBeneficiaryForm.clsr_birth_date" />
                  </div>
                  <div class="qf-item">
                    <label>급여종류</label>
                    <input v-model="newBeneficiaryForm.clsr_service_type" placeholder="방문요양 등" />
                  </div>
                  <div class="qf-item">
                    <label>입소일</label>
                    <YmdDateInput v-model="newBeneficiaryForm.clsr_enter_date" />
                  </div>
                  <div class="qf-item">
                    <label>연락처</label>
                    <input v-model="newBeneficiaryForm.clsr_phone" placeholder="연락처" />
                  </div>
                  <div class="qf-item qf-grow">
                    <label>&nbsp;</label>
                    <input
                      placeholder="Enter로 등록"
                      @keydown.enter.prevent="saveNewBeneficiary"
                    />
                  </div>
                  <div class="qf-item qf-action">
                    <button
                      type="button"
                      class="qf-register-btn"
                      @click="saveNewBeneficiary"
                      :disabled="!canSaveNew || beneficiarySaving"
                    >
                      <v-progress-circular v-if="beneficiarySaving" indeterminate size="14" width="2" color="white" />
                      <template v-else>등록</template>
                    </button>
                  </div>
                </div>
              </div>
            </transition>

            <div class="emp-table-wrap">
              <table class="emp-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th class="sortable" @click="toggleBeneficiarySort('clsr_recipient_name')">
                      수급자명 <v-icon size="14">{{ getBeneficiarySortIcon('clsr_recipient_name') }}</v-icon>
                    </th>
                    <th class="sortable" @click="toggleBeneficiarySort('clsr_grade')">
                      등급 <v-icon size="14">{{ getBeneficiarySortIcon('clsr_grade') }}</v-icon>
                    </th>
                    <th>주민등록번호</th>
                    <th class="sortable" @click="toggleBeneficiarySort('clsr_service_type')">
                      급여종류 <v-icon size="14">{{ getBeneficiarySortIcon('clsr_service_type') }}</v-icon>
                    </th>
                    <th class="sortable" @click="toggleBeneficiarySort('clsr_approval_no')">
                      인정번호 <v-icon size="14">{{ getBeneficiarySortIcon('clsr_approval_no') }}</v-icon>
                    </th>
                    <th class="sortable" @click="toggleBeneficiarySort('month_status')">
                      현황 <v-icon size="14">{{ getBeneficiarySortIcon('month_status') }}</v-icon>
                    </th>
                    <th class="sortable" @click="toggleBeneficiarySort('clsr_source_label')">
                      수집구분 <v-icon size="14">{{ getBeneficiarySortIcon('clsr_source_label') }}</v-icon>
                    </th>
                    <th class="col-schedule">일정</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="beneficiaryLoading">
                    <td colspan="9" class="empty-row">
                      <v-progress-circular indeterminate color="primary" size="32" />
                    </td>
                  </tr>
                  <tr v-else-if="filteredBeneficiaryList.length === 0">
                    <td colspan="9" class="empty-row">
                      해당 연월에 표시할 수급자가 없습니다.
                      <button v-if="!showBeneficiaryQuickAdd" type="button" class="hr-empty-add-btn" @click="showBeneficiaryQuickAdd = true">간편등록</button>
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, idx) in filteredBeneficiaryList"
                    :key="`${item.clsr_source}-${item.clsr_idx}`"
                    class="row-clickable"
                    @click="openBeneficiaryDetail(item)"
                  >
                    <td>{{ idx + 1 }}</td>
                    <td class="td-name">
                      <div class="name-cell">
                        <div class="avatar" :style="{ background: getAvatarColor(item.clsr_recipient_name) }">
                          {{ getInitial(item.clsr_recipient_name) }}
                        </div>
                        <span>{{ item.clsr_recipient_name }}</span>
                        <span v-if="isBeneficiaryReenter(item)" class="month-badge enter">재입소</span>
                        <span v-if="item.is_month_enter" class="month-badge enter">당월입소</span>
                        <span v-if="item.is_month_leave" class="month-badge leave">당월퇴소</span>
                      </div>
                    </td>
                    <td>{{ item.clsr_grade || '-' }}</td>
                    <td class="td-ssn">
                      <template v-if="beneficiarySsnFront(item) !== '******'">
                        <span class="emp-ssn-line">{{ beneficiarySsnFront(item) }}-</span>
                        <span
                          class="emp-ssn-line"
                          :class="isBeneficiarySsnMissing(item) ? 'emp-ssn-line--missing' : 'emp-ssn-line--mask'"
                        >{{ isBeneficiarySsnMissing(item) ? '미등록' : '*******' }}</span>
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td>{{ item.clsr_service_type || '-' }}</td>
                    <td>{{ item.clsr_approval_no || '-' }}</td>
                    <td>
                      <span class="status-chip" :class="item.month_status === '입소' ? 'active' : 'inactive'">
                        {{ item.month_status }}
                      </span>
                    </td>
                    <td>
                      <span class="source-chip" :class="item.clsr_source === 'auto' ? 'auto' : 'manual'">
                        {{ item.clsr_source_label }}
                      </span>
                    </td>
                    <td class="col-schedule">
                      <button
                        type="button"
                        class="hr-schedule-btn"
                        :disabled="!canOpenBeneficiarySchedule(item)"
                        :title="canOpenBeneficiarySchedule(item) ? '월간 일정 보기' : '인정번호가 있어야 일정을 조회할 수 있습니다'"
                        @click.stop="openBeneficiarySchedule(item)"
                      >
                        <v-icon size="16">mdi-calendar-clock</v-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BeneficiaryCalendarModal
      v-model="showBeneficiaryCalendar"
      :beneficiary="calendarBeneficiary"
      :beneficiaries="calendarBeneficiaryList"
      :member-code="memberCode"
      :biz-gubun="selectedBizGubun"
      :year="selectedYear"
      :month="selectedMonth"
    />

    <ScheduleCalendarModal
      v-model="showEmployeeCalendar"
      :caregiver="calendarCaregiver"
      :caregivers="calendarCaregiverList"
      :member-code="memberCode"
      :biz-gubun="selectedBizGubun"
      :year="selectedYear"
      :month="selectedMonth"
    />

    <BeneficiaryAllScheduleModal
      v-model="showAllBeneficiarySchedule"
      :member-code="memberCode"
      :biz-gubun="selectedBizGubun"
      :year="selectedYear"
      :month="selectedMonth"
      @open-recipient="onOpenRecipientFromAllSchedule"
    />

    <v-dialog
      v-model="employeeDetailDialog"
      max-width="560"
      persistent
      content-class="hr-detail-dialog-shell"
    >
      <div v-if="selectedEmployee" class="hr-detail-modal">
        <header class="hr-detail-modal__header">
          <div class="hr-detail-modal__profile">
            <div
              class="hr-detail-modal__avatar"
              :style="{ background: getAvatarColor(selectedEmployee.clci_name) }"
            >
              {{ getInitial(selectedEmployee.clci_name) }}
            </div>
            <div class="hr-detail-modal__title-wrap">
              <h3>{{ selectedEmployee.clci_name }}</h3>
              <span class="hr-detail-modal__subtitle">{{ selectedEmployee.clci_job_type || '직종 미등록' }}</span>
              <div class="hr-detail-modal__badges">
                <span class="hr-detail-modal__chip hr-detail-modal__chip--source" :class="selectedEmployee.clci_source">
                  {{ selectedEmployee.clci_source_label }}
                </span>
                <span
                  class="hr-detail-modal__chip hr-detail-modal__chip--status"
                  :class="selectedEmployee.month_status === '현원' ? 'is-active' : 'is-inactive'"
                >
                  {{ selectedEmployee.month_status }}
                </span>
                <span
                  v-if="isEmployeeAppLinked(selectedEmployee)"
                  class="hr-detail-modal__chip hr-detail-modal__chip--app"
                  :title="employeeAppLinkTitle(selectedEmployee)"
                >
                  앱연동{{ selectedEmployee.app_link_label ? ` · ${selectedEmployee.app_link_label}` : '' }}
                </span>
                <span v-if="selectedEmployee.is_month_enter" class="hr-detail-modal__chip hr-detail-modal__chip--enter">당월입사</span>
                <span v-if="selectedEmployee.is_month_leave" class="hr-detail-modal__chip hr-detail-modal__chip--leave">당월퇴사</span>
              </div>
            </div>
          </div>
          <button type="button" class="hr-detail-modal__close" aria-label="닫기" @click="closeEmployeeDetail">
            <v-icon size="20">mdi-close</v-icon>
          </button>
        </header>

        <div class="hr-detail-modal__body">
          <EmployeeProfileLinkPanel
            v-if="isEmployeeAppLinked(selectedEmployee)"
            :m-code="String(memberCode)"
            :source="selectedEmployee.clci_source === 'manual' ? 'manual' : 'auto'"
            :clci-idx="Number(selectedEmployee.clci_idx)"
            @applied="onEmployeeProfileLinked"
          />
          <div class="hr-detail-modal__form">
            <div class="hr-detail-modal__section">기본 정보</div>
            <div class="hr-detail-modal__field">
              <label>성명</label>
              <input v-model="employeeEditForm.clci_name" type="text" />
            </div>
            <div class="hr-detail-modal__field">
              <label>생년월일(8자리) <em>*</em></label>
              <input
                class="hr-birth-ymd-input"
                :value="employeeEditForm.clci_birth_ymd"
                type="text"
                maxlength="8"
                inputmode="numeric"
                autocomplete="off"
                placeholder="YYYYMMDD"
                @input="onEmployeeBirthYmdInput(employeeEditForm, $event)"
              />
            </div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <label class="hr-ssn-label">
                주민등록번호
                <span v-if="selectedEmployee.clci_has_ssn_back" class="hr-ssn-state hr-ssn-state--saved">뒷자리 등록됨</span>
                <span v-else class="hr-ssn-state hr-ssn-state--missing">뒷자리 없음</span>
              </label>
              <div
                v-if="selectedEmployee && isEmployeeSsnMissing(selectedEmployee)"
                class="hr-ssn-guide hr-ssn-guide--detail"
              >
                <v-icon size="15" color="#e65100">mdi-alert-circle-outline</v-icon>
                <div class="hr-ssn-guide__body">
                  <p class="hr-ssn-guide__title">주민번호가 등록되지 않았습니다</p>
                  <p class="hr-ssn-guide__text">아래 뒷자리 7자리를 입력한 뒤 저장해 주세요. 임금·4대보험 계산에 필요합니다.</p>
                </div>
              </div>
              <div class="hr-ssn-row">
                <span class="hr-ssn-front">{{ formatSsnFront(employeeEditForm.clci_birth_date) }}</span>
                <span class="hr-ssn-dash">-</span>
                <span
                  v-if="selectedEmployee.clci_has_ssn_back && !employeeSsnEditing"
                  class="hr-ssn-back-mask"
                  :class="{ 'is-revealed': ssnRevealed && ssnRevealedValue }"
                >{{ ssnRevealed && ssnRevealedValue ? ssnRevealedValue : '●●●●●●●' }}</span>
                <input
                  v-else
                  v-model="employeeEditForm.clci_ssn_back"
                  class="hr-ssn-back-input"
                  type="text"
                  maxlength="7"
                  inputmode="numeric"
                  autocomplete="off"
                  :placeholder="selectedEmployee.clci_has_ssn_back ? '새 뒷자리 7자리' : '뒷자리 7자리'"
                />
                <button
                  v-if="selectedEmployee.clci_has_ssn_back && !employeeSsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  :disabled="ssnRevealing"
                  @click="revealEmployeeSsn"
                >
                  <v-icon v-if="ssnRevealing" size="14" class="mdi-spin">mdi-loading</v-icon>
                  <template v-else>{{ ssnRevealed ? '숨기기' : '보기' }}</template>
                </button>
                <button
                  v-if="selectedEmployee.clci_has_ssn_back && !employeeSsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  @click="startEmployeeSsnEdit"
                >변경</button>
                <button
                  v-if="selectedEmployee.clci_has_ssn_back && employeeSsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  @click="cancelEmployeeSsnEdit"
                >취소</button>
              </div>
              <p v-if="selectedEmployee.clci_has_ssn_back && !employeeSsnEditing" class="hr-ssn-hint hr-ssn-hint--saved">뒷자리 7자리가 저장되어 있습니다. 숫자를 바꿀 때만 변경을 누르세요.</p>
              <p v-else-if="selectedEmployee.clci_has_ssn_back" class="hr-ssn-hint">새 뒷자리를 입력한 뒤 저장하면 바뀝니다. 비워 두면 기존 값이 유지됩니다.</p>
            </div>
            <div class="hr-detail-modal__field">
              <label>직종</label>
              <select v-model="employeeEditForm.clci_job_type">
                <option value="">선택</option>
                <option v-for="pos in positionOptions" :key="pos" :value="pos">{{ pos }}</option>
              </select>
            </div>
            <div class="hr-detail-modal__field">
              <label>연락처</label>
              <input v-model="employeeEditForm.clci_phone" type="text" />
            </div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <label>이메일</label>
              <input v-model="employeeEditForm.clci_email" type="email" />
            </div>

            <div class="hr-detail-modal__section">근무 정보</div>
            <div
              v-if="employmentLines(selectedEmployee).length > 1"
              class="hr-detail-modal__field hr-detail-modal__field--full"
            >
              <div class="hr-employment-lines">
                <div
                  v-for="line in employmentLines(selectedEmployee)"
                  :key="`${line.clci_source}-${line.clci_idx}-detail`"
                  class="hr-employment-line"
                  :class="{ 'is-applied': isWageEmployment(selectedEmployee, line) }"
                >
                  <span class="hr-employment-line__src">{{ line.clci_source_label }}</span>
                  <span class="hr-employment-line__date">{{ formatDate(line.clci_work_start_date) }}</span>
                  <span class="hr-employment-line__end">{{ leaveDateOf(line) ? formatDate(line.clci_work_end_date) : '재직' }}</span>
                </div>
              </div>
              <p class="hr-employment-note">{{ wageEmploymentNote(selectedEmployee) }}</p>
            </div>
            <div class="hr-detail-modal__field">
              <label>
                입사일 <em>*</em>
                <span v-if="hasSeveralEmployments(selectedEmployee)" class="hr-field-source">{{ employmentSourceLabel(selectedEmployee.clci_source) }}</span>
              </label>
              <YmdDateInput v-model="employeeEditForm.clci_work_start_date" />
            </div>
            <div class="hr-detail-modal__field">
              <label>
                퇴사일
                <span v-if="hasSeveralEmployments(selectedEmployee)" class="hr-field-source">{{ employmentSourceLabel(selectedEmployee.clci_source) }}</span>
              </label>
              <YmdDateInput v-model="employeeEditForm.clci_work_end_date" />
            </div>

            <div class="hr-detail-modal__section">주소</div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <div class="hr-addr-row">
                <input
                  :value="employeeEditForm.clci_zipcode"
                  class="hr-addr-zip"
                  type="text"
                  readonly
                  placeholder="우편번호"
                  @click="openPostcode('employee')"
                />
                <button type="button" class="hr-addr-search-btn" @click="openPostcode('employee')">
                  <v-icon size="15">mdi-map-search-outline</v-icon>
                  주소 찾기
                </button>
              </div>
              <input
                :value="employeeEditForm.clci_addr1"
                class="hr-addr1"
                type="text"
                readonly
                placeholder="기본 주소 (주소 찾기로 선택하세요)"
                @click="openPostcode('employee')"
              />
              <input
                v-model="employeeEditForm.clci_addr2"
                type="text"
                placeholder="상세 주소 (동·호수 등)"
                maxlength="100"
              />
            </div>

            <div
              v-if="selectedEmployee.clci_wdate || selectedEmployee.clci_rdate"
              class="hr-detail-modal__section"
            >수집 정보</div>
            <div
              v-if="selectedEmployee.clci_wdate || selectedEmployee.clci_rdate"
              class="hr-detail-modal__field hr-detail-modal__field--full"
            >
              <label>수집일시</label>
              <input
                :value="formatDateTime(selectedEmployee.clci_wdate || selectedEmployee.clci_rdate)"
                type="text"
                readonly
              />
            </div>
          </div>
        </div>

        <footer class="hr-detail-modal__footer">
          <v-btn
            v-if="selectedEmployee.clci_source === 'manual'"
            variant="flat"
            class="btn-delete"
            :loading="employeeDeleting"
            @click="deleteEmployee"
          >삭제</v-btn>
          <v-spacer />
          <v-btn
            variant="flat"
            class="btn-confirm"
            :disabled="!canOpenEmployeeSchedule(selectedEmployee)"
            @click="openEmployeeScheduleFromDetail"
          >월간 일정</v-btn>
          <v-btn variant="text" class="btn-cancel" @click="closeEmployeeDetail">닫기</v-btn>
          <v-btn
            variant="flat"
            class="btn-save"
            :loading="employeeSaving"
            :disabled="!employeeEditForm.clci_work_start_date"
            :title="employeeEditForm.clci_work_start_date ? undefined : '입사일을 입력해야 저장할 수 있습니다.'"
            @click="saveEmployeeEdit"
          >저장</v-btn>
        </footer>
      </div>
    </v-dialog>

    <v-dialog
      v-model="beneficiaryDetailDialog"
      max-width="680"
      persistent
      content-class="hr-detail-dialog-shell"
    >
      <div v-if="selectedBeneficiary" class="hr-detail-modal">
        <header class="hr-detail-modal__header">
          <div class="hr-detail-modal__profile">
            <div
              class="hr-detail-modal__avatar"
              :style="{ background: getAvatarColor(selectedBeneficiary.clsr_recipient_name) }"
            >
              {{ getInitial(selectedBeneficiary.clsr_recipient_name) }}
            </div>
            <div class="hr-detail-modal__title-wrap">
              <h3>{{ selectedBeneficiary.clsr_recipient_name }}</h3>
              <span class="hr-detail-modal__subtitle">{{ selectedBeneficiary.clsr_service_type || '급여종류 미등록' }}</span>
              <div class="hr-detail-modal__badges">
                <span class="hr-detail-modal__chip hr-detail-modal__chip--source" :class="selectedBeneficiary.clsr_source">
                  {{ selectedBeneficiary.clsr_source_label }}
                </span>
                <span
                  class="hr-detail-modal__chip hr-detail-modal__chip--status"
                  :class="selectedBeneficiary.month_status === '입소' ? 'is-active' : 'is-inactive'"
                >
                  {{ selectedBeneficiary.month_status }}
                </span>
                <span v-if="selectedBeneficiary.is_month_enter" class="hr-detail-modal__chip hr-detail-modal__chip--enter">당월입소</span>
                <span v-if="selectedBeneficiary.is_month_leave" class="hr-detail-modal__chip hr-detail-modal__chip--leave">당월퇴소</span>
                <span
                  v-if="isBeneficiaryReenter(selectedBeneficiary)"
                  class="hr-detail-modal__chip hr-detail-modal__chip--enter"
                >재입소</span>
              </div>
            </div>
          </div>
          <button type="button" class="hr-detail-modal__close" aria-label="닫기" @click="closeBeneficiaryDetail">
            <v-icon size="20">mdi-close</v-icon>
          </button>
        </header>

        <div class="hr-detail-modal__tabs">
          <button
            type="button"
            class="hr-detail-modal__tab"
            :class="{ 'is-active': beneficiaryDetailTab === 'info' }"
            @click="beneficiaryDetailTab = 'info'"
          >정보</button>
          <button
            type="button"
            class="hr-detail-modal__tab"
            :class="{ 'is-active': beneficiaryDetailTab === 'history' }"
            @click="beneficiaryDetailTab = 'history'"
          >이력</button>
        </div>

        <div class="hr-detail-modal__body">
          <div v-if="beneficiaryDetailTab === 'history'" class="hr-detail-modal__form">
            <p v-if="beneficiaryHistoryLoading" class="recipient-history-empty">이력을 불러오는 중...</p>
            <p v-else-if="beneficiaryHistory.length === 0" class="recipient-history-empty">
              아직 이력이 없습니다. 등급을 바꾸면 여기에 남습니다.
            </p>
            <ul v-else class="recipient-history-list">
              <li v-for="item in beneficiaryHistory" :key="item.clrh_idx" class="recipient-history-item">
                <span class="recipient-history-item__dot" :class="item.clrh_kind === 'grade' ? 'is-grade' : 'is-stay'"></span>
                <div>
                  <strong>{{ historyItemTitle(item) }}</strong>
                  <span>{{ historyItemMeta(item) }}</span>
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="hr-detail-modal__form">
            <div class="hr-detail-modal__section">기본 정보</div>
            <div class="hr-detail-modal__field">
              <label>수급자명</label>
              <input v-model="beneficiaryEditForm.clsr_recipient_name" type="text" />
            </div>
            <div class="hr-detail-modal__field">
              <label>생년월일</label>
              <YmdDateInput v-model="beneficiaryEditForm.clsr_birth_date" />
            </div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <label class="hr-ssn-label">
                주민등록번호
                <span v-if="selectedBeneficiary.clsr_has_ssn_back" class="hr-ssn-state hr-ssn-state--saved">뒷자리 등록됨</span>
                <span v-else class="hr-ssn-state hr-ssn-state--missing">뒷자리 없음</span>
              </label>
              <div class="hr-ssn-row">
                <input
                  v-model="beneficiaryEditForm.clsr_ssn_front"
                  class="hr-ssn-front-input"
                  type="text"
                  maxlength="6"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="앞자리 6자리"
                />
                <span class="hr-ssn-dash">-</span>
                <span
                  v-if="selectedBeneficiary.clsr_has_ssn_back && !beneficiarySsnEditing"
                  class="hr-ssn-back-mask"
                  :class="{ 'is-revealed': benSsnRevealed && benSsnRevealedValue }"
                >{{ benSsnRevealed && benSsnRevealedValue ? benSsnRevealedValue : '●●●●●●●' }}</span>
                <input
                  v-else
                  v-model="beneficiaryEditForm.clsr_ssn_back"
                  class="hr-ssn-back-input"
                  type="text"
                  maxlength="7"
                  inputmode="numeric"
                  autocomplete="off"
                  :placeholder="selectedBeneficiary.clsr_has_ssn_back ? '새 뒷자리 7자리' : '뒷자리 7자리'"
                />
                <button
                  v-if="selectedBeneficiary.clsr_has_ssn_back && !beneficiarySsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  :disabled="benSsnRevealing"
                  @click="revealBeneficiarySsn"
                >
                  <v-icon v-if="benSsnRevealing" size="14" class="mdi-spin">mdi-loading</v-icon>
                  <template v-else>{{ benSsnRevealed ? '숨기기' : '보기' }}</template>
                </button>
                <button
                  v-if="selectedBeneficiary.clsr_has_ssn_back && !beneficiarySsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  @click="startBeneficiarySsnEdit"
                >변경</button>
                <button
                  v-if="selectedBeneficiary.clsr_has_ssn_back && beneficiarySsnEditing"
                  type="button"
                  class="hr-ssn-reveal-btn"
                  @click="cancelBeneficiarySsnEdit"
                >취소</button>
              </div>
              <p v-if="selectedBeneficiary.clsr_has_ssn_back && !beneficiarySsnEditing" class="hr-ssn-hint hr-ssn-hint--saved">뒷자리 7자리가 저장되어 있습니다. 숫자를 바꿀 때만 변경을 누르세요.</p>
              <p v-else-if="selectedBeneficiary.clsr_has_ssn_back" class="hr-ssn-hint">새 뒷자리를 입력한 뒤 저장하면 바뀝니다. 비워 두면 기존 값이 유지됩니다.</p>
            </div>
            <div class="hr-detail-modal__field">
              <label>인정번호</label>
              <input v-model="beneficiaryEditForm.clsr_approval_no" type="text" placeholder="L0000000000" maxlength="11" />
            </div>
            <div class="hr-detail-modal__field">
              <label>등급</label>
              <input v-model="beneficiaryEditForm.clsr_grade" type="text" placeholder="예: 4등급" />
            </div>
            <div class="hr-detail-modal__field">
              <label>급여종류</label>
              <input v-model="beneficiaryEditForm.clsr_service_type" type="text" />
            </div>
            <div class="hr-detail-modal__field">
              <label>연락처</label>
              <input v-model="beneficiaryEditForm.clsr_phone" type="text" />
            </div>

            <div class="hr-detail-modal__section">이용 정보</div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <div class="recipient-stay-now" :class="beneficiaryHasLeft ? 'is-left' : 'is-in'">
                <span class="recipient-stay-now__mark"></span>
                <div>
                  <strong>{{ beneficiaryStayHeadline }}</strong>
                  <p>{{ beneficiaryStayDetail }}</p>
                </div>
              </div>
            </div>
            <div class="hr-detail-modal__field">
              <label>입소일</label>
              <YmdDateInput v-model="beneficiaryEditForm.clsr_enter_date" />
            </div>
            <div class="hr-detail-modal__field">
              <label>퇴소일</label>
              <YmdDateInput v-model="beneficiaryEditForm.clsr_leave_date" />
            </div>

            <div v-if="!beneficiarySavedLeave" class="recipient-stay-action hr-detail-modal__field--full">
              <div class="recipient-stay-action__title">퇴소 처리</div>
              <p>이번 이용을 끝냅니다. 입소일과 등급은 그대로 둡니다.</p>
              <div class="recipient-stay-action__row">
                <YmdDateInput v-model="stayLeaveDate" />
                <button type="button" class="recipient-stay-action__btn" :disabled="beneficiaryStayActing" @click="recordBeneficiaryLeave">
                  퇴소로 기록
                </button>
              </div>
            </div>
            <div v-else-if="beneficiaryHasLeft" class="recipient-stay-action hr-detail-modal__field--full">
              <div class="recipient-stay-action__title">다시 입소</div>
              <p>지난 이용은 이력에 남고, 퇴소일은 비워집니다. 등급이 바뀌었으면 여기서 같이 고칩니다.</p>
              <div class="recipient-stay-action__row">
                <YmdDateInput v-model="reenterDate" />
                <input v-model="reenterGrade" type="text" placeholder="등급" />
                <button type="button" class="recipient-stay-action__btn" :disabled="beneficiaryStayActing" @click="recordBeneficiaryReenter">
                  다시 입소로 기록
                </button>
              </div>
            </div>

            <div class="hr-detail-modal__section">주소</div>
            <div class="hr-detail-modal__field hr-detail-modal__field--full">
              <div class="hr-addr-row">
                <input
                  :value="beneficiaryEditForm.clsr_zipcode"
                  class="hr-addr-zip"
                  type="text"
                  readonly
                  placeholder="우편번호"
                  @click="openPostcode('beneficiary')"
                />
                <button type="button" class="hr-addr-search-btn" @click="openPostcode('beneficiary')">
                  <v-icon size="15">mdi-map-search-outline</v-icon>
                  주소 찾기
                </button>
              </div>
              <input
                :value="beneficiaryEditForm.clsr_addr1"
                class="hr-addr1"
                type="text"
                readonly
                placeholder="기본 주소 (주소 찾기로 선택하세요)"
                @click="openPostcode('beneficiary')"
              />
              <input
                v-model="beneficiaryEditForm.clsr_addr2"
                type="text"
                placeholder="상세 주소 (동·호수 등)"
                maxlength="100"
              />
            </div>

            <div
              v-if="selectedBeneficiary.clsr_wdate || selectedBeneficiary.clsr_rdate"
              class="hr-detail-modal__section"
            >수집 정보</div>
            <div
              v-if="selectedBeneficiary.clsr_wdate || selectedBeneficiary.clsr_rdate"
              class="hr-detail-modal__field hr-detail-modal__field--full"
            >
              <label>수집일시</label>
              <input
                :value="formatDateTime(selectedBeneficiary.clsr_wdate || selectedBeneficiary.clsr_rdate)"
                type="text"
                readonly
              />
            </div>
          </div>
        </div>

        <footer class="hr-detail-modal__footer">
          <v-btn
            v-if="selectedBeneficiary.clsr_source === 'manual'"
            variant="flat"
            class="btn-delete"
            :loading="beneficiaryDeleting"
            @click="deleteBeneficiary"
          >삭제</v-btn>
          <v-spacer />
          <v-btn
            variant="flat"
            class="btn-confirm"
            :disabled="!canOpenBeneficiarySchedule(selectedBeneficiary)"
            @click="openBeneficiaryScheduleFromDetail"
          >월간 일정</v-btn>
          <v-btn variant="text" class="btn-cancel" @click="closeBeneficiaryDetail">닫기</v-btn>
          <v-btn
            v-if="beneficiaryDetailTab === 'info'"
            variant="flat"
            class="btn-save"
            :loading="beneficiarySaving"
            @click="saveBeneficiaryEdit"
          >저장</v-btn>
        </footer>
      </div>
    </v-dialog>

    <!-- 수급자 엑셀 업로드 (인사관리 → 회계용 동시 반영) -->
    <v-dialog v-model="beneficiaryExcelModal" max-width="520" persistent>
      <div class="hr-ben-excel-modal">
        <header class="hr-ben-excel-header">
          <div>
            <h3>수급자 엑셀 업로드</h3>
            <p>인사관리와 회계(통장·수납) 수급자에 함께 반영됩니다.</p>
          </div>
          <button type="button" class="hr-ben-excel-close" @click="closeBeneficiaryExcelModal">
            <v-icon size="20">mdi-close</v-icon>
          </button>
        </header>
        <div class="hr-ben-excel-body">
          <button type="button" class="hr-ben-excel-template" :disabled="beneficiaryExcelUploading" @click="downloadBeneficiaryTemplate">
            <v-icon size="16">mdi-download</v-icon>
            양식 다운로드
          </button>
          <label class="hr-ben-excel-drop">
            <input
              ref="beneficiaryExcelInputRef"
              type="file"
              accept=".xlsx,.xls"
              hidden
              @change="onBeneficiaryExcelSelected"
            />
            <v-icon size="28" color="#1e7d47">mdi-file-excel</v-icon>
            <span>{{ beneficiaryExcelFileName || '엑셀 파일 선택 (.xlsx)' }}</span>
          </label>
          <p v-if="beneficiaryExcelMessage" class="hr-ben-excel-msg" :class="{ error: beneficiaryExcelError }">
            {{ beneficiaryExcelMessage }}
          </p>
        </div>
        <footer class="hr-ben-excel-footer">
          <button type="button" class="hr-ben-excel-cancel" :disabled="beneficiaryExcelUploading" @click="closeBeneficiaryExcelModal">취소</button>
          <button
            type="button"
            class="hr-ben-excel-upload"
            :disabled="!beneficiaryExcelFile || beneficiaryExcelUploading"
            @click="uploadBeneficiaryExcel"
          >
            {{ beneficiaryExcelUploading ? '업로드 중…' : '업로드' }}
          </button>
        </footer>
      </div>
    </v-dialog>

    <DaumPostcodeDialog
      v-model="postcodeDialog"
      @select="onPostcodeSelect"
    />

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch, inject, nextTick } from 'vue';
import { usePageTabNav } from '@/composables/usePageTabNav';
import type { Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { employeeApi, beneficiaryApi, homeScheduleApi } from '@/services/api';
import EmployeeProfileLinkPanel from '@/components/employee/EmployeeProfileLinkPanel.vue';
import { useJobTypes } from '@/composables/useJobTypes';
import { EMPLOYEE_POSITION_OPTIONS } from '@/constants/employeePositions';
import {
  findEmployeeDuplicate,
  getEmployeeRowIdentity,
  DUPLICATE_EMPLOYEE_MESSAGE,
} from '@/utils/employeeDuplicate';
import BeneficiaryCalendarModal from '@/components/member/schedule/BeneficiaryCalendarModal.vue';
import BeneficiaryAllScheduleModal from '@/components/member/schedule/BeneficiaryAllScheduleModal.vue';
import ScheduleCalendarModal from '@/components/member/schedule/ScheduleCalendarModal.vue';
import { downloadPdfBlob, getApiErrorMessage } from '@/utils/downloadPdf';
import LtcsRequestSidebarButton from '@/components/member/request/LtcsRequestSidebarButton.vue';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import DaumPostcodeDialog from '@/components/common/DaumPostcodeDialog.vue';
type HrTab = 'employee' | 'beneficiary';

interface CalendarBeneficiary {
  patient_code: string;
  patient_name: string;
}

interface CalendarCaregiver {
  emp_name: string;
  emp_birth: string;
  emp_job?: string;
}

const route = useRoute();
const router = useRouter();
const memberData = inject<any>('memberData');
const selectedBizGubunRef = inject<Ref<string>>('selectedBizGubun');
const selectedBizGubun = computed(() => selectedBizGubunRef?.value || '');

const memberCode = computed(() => {
  return (route.params.memberCode as string) || memberData?.value?.m_code || '';
});

const activeTab = ref<HrTab>('employee');

const setActiveTab = (tab: HrTab) => {
  activeTab.value = tab;
  router.replace({ query: { ...route.query, tab } });
};

const hrPageTabs = computed(() => [
  { key: 'employee', title: '사원' },
  { key: 'beneficiary', title: '수급자' },
]);
usePageTabNav('wage-hr', hrPageTabs, activeTab, (key) => {
  if (key === 'employee' || key === 'beneficiary') setActiveTab(key);
});

/** 직종 선택 목록 — DB caion_job_type (관리자 직종관리) */
const { positionOptions, defaultPosition, isEmployeePosition, loadJobTypes: refreshJobTypes } = useJobTypes();

// 현원·퇴사, 일정표, 자료요청은 이번 달 기준. 화면에서 연월은 고르지 않는다.
const selectedYear = ref(new Date().getFullYear());
const selectedMonth = ref(new Date().getMonth() + 1);
const selectedYearMonth = computed(
  () => `${selectedYear.value}-${String(selectedMonth.value).padStart(2, '0')}`
);
const scheduleYearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

// ── 사원 (LTCS 자동수집 + 직접등록 UNION) ──
const employeeLoading = ref(false);
const employeeList = ref<any[]>([]);
const employeeStats = ref({
  total: 0,
  hyunwon: 0,
  toesaw: 0,
  monthEnter: 0,
  monthLeave: 0,
});
const employeeMeta = ref<{ lastAutoCollectWdate?: string | null; yearMonth?: string }>({});
const employeeStatusFilter = ref('');
const employeeSearchText = ref('');
const employeeSortKey = ref('clci_name');
const employeeSortOrder = ref<'asc' | 'desc'>('asc');
const employeeDetailDialog = ref(false);
const selectedEmployee = ref<any>(null);
const showEmployeeQuickAdd = ref(false);
const employeeSaving = ref(false);
const employeeDeleting = ref(false);
const ssnRevealing = ref(false);
const ssnRevealed = ref(false);
const ssnRevealedValue = ref('');
const employeeSsnEditing = ref(false);

type EmployeeQuickRow = {
  _key: number;
  clci_name: string;
  clci_birth_ymd: string;
  clci_birth_date: string;
  clci_ssn_back: string;
  clci_job_type: string;
  clci_work_start_date: string;
  clci_phone: string;
  clci_email: string;
};

let employeeQuickRowSeq = 1;
const createEmptyEmployeeRow = (): EmployeeQuickRow => ({
  _key: employeeQuickRowSeq++,
  clci_name: '',
  clci_birth_ymd: '',
  clci_birth_date: '',
  clci_ssn_back: '',
  clci_job_type: defaultPosition.value || (EMPLOYEE_POSITION_OPTIONS[0] as string),
  clci_work_start_date: '',
  clci_phone: '',
  clci_email: '',
});

const newEmployeeRows = ref<EmployeeQuickRow[]>([createEmptyEmployeeRow()]);

const addEmployeeQuickRow = () => {
  newEmployeeRows.value.push(createEmptyEmployeeRow());
};

const removeEmployeeQuickRow = (idx: number) => {
  if (newEmployeeRows.value.length <= 1) return;
  newEmployeeRows.value.splice(idx, 1);
};

const resetEmployeeQuickRows = () => {
  newEmployeeRows.value = [createEmptyEmployeeRow()];
};

const employeeEditForm = ref({
  clci_name: '',
  clci_birth_ymd: '',
  clci_birth_date: '',
  clci_ssn_back: '',
  clci_job_type: '',
  clci_work_start_date: '',
  clci_work_end_date: '',
  clci_phone: '',
  clci_email: '',
  clci_zipcode: '',
  clci_addr1: '',
  clci_addr2: '',
});

// ── 다음주소찾기 (사원/수급자 공용) ──
const postcodeDialog = ref(false);
const postcodeTarget = ref<'employee' | 'beneficiary'>('employee');

const openPostcode = (target: 'employee' | 'beneficiary') => {
  postcodeTarget.value = target;
  postcodeDialog.value = true;
};

const onPostcodeSelect = (data: { zonecode: string; address: string }) => {
  if (postcodeTarget.value === 'employee') {
    employeeEditForm.value.clci_zipcode = data.zonecode;
    employeeEditForm.value.clci_addr1 = data.address;
  } else {
    beneficiaryEditForm.value.clsr_zipcode = data.zonecode;
    beneficiaryEditForm.value.clsr_addr1 = data.address;
  }
};

const isValidSsnBack = (raw: string) => /^\d{7}$/.test(String(raw || '').replace(/\D/g, ''));

/** 생년월일 8자리(YYYYMMDD) → YYYY-MM-DD. 1900년부터 올해까지, 실제 있는 날짜만. */
const birthDateFromYmd8 = (raw: string): string => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!/^\d{8}$/.test(digits)) return '';
  const yyyy = Number(digits.slice(0, 4));
  const mm = Number(digits.slice(4, 6));
  const dd = Number(digits.slice(6, 8));
  const currentYear = new Date().getFullYear();
  if (yyyy < 1900 || yyyy > currentYear || mm < 1 || mm > 12 || dd < 1 || dd > 31) return '';
  const iso = `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
  const check = new Date(`${iso}T00:00:00`);
  if (check.getFullYear() !== yyyy || check.getMonth() + 1 !== mm || check.getDate() !== dd) return '';
  return iso;
};

const ymd8FromBirthDate = (birthDate: string): string => {
  const d = formatDate(birthDate);
  if (!d || d === '-') return '';
  const digits = d.replace(/\D/g, '');
  return digits.length === 8 ? digits : '';
};

const onEmployeeBirthYmdInput = (
  target: { clci_birth_ymd: string; clci_birth_date: string },
  event: Event
) => {
  const el = event.target as HTMLInputElement;
  const digits = String(el.value || '').replace(/\D/g, '').slice(0, 8);
  target.clci_birth_ymd = digits;
  target.clci_birth_date = birthDateFromYmd8(digits);
  if (el.value !== digits) el.value = digits;
};

const employeeQuickAddJoinReady = computed(() =>
  newEmployeeRows.value.every((row) => !!row.clci_work_start_date)
);

/** 주민번호 뒷자리 미등록 여부 (API: clci_has_ssn_back) */
const isEmployeeSsnMissing = (row: any): boolean => !row?.clci_has_ssn_back;

const employeeSsnMissingCount = computed(
  () => employeeList.value.filter((r) => isEmployeeSsnMissing(r)).length
);

const isEmployeeAppLinked = (row: any): boolean =>
  row?.app_linked === true || row?.app_linked === 1 || row?.app_linked === 'Y';

const employeeAppLinkedCount = computed(
  () => employeeList.value.filter((r) => isEmployeeAppLinked(r)).length
);

const employeeAppLinkTitle = (row: any): string => {
  const label = String(row?.app_link_label || '').trim();
  return label ? `카이온 앱 연동 · ${label}` : '카이온 앱 연동';
};

const getEmployeeRowMissingFields = (f: EmployeeQuickRow): string[] => {
  const missing: string[] = [];
  if (!f.clci_name.trim()) missing.push('성명');
  if (!birthDateFromYmd8(f.clci_birth_ymd)) missing.push('생년월일(8자리)');
  if (!isValidSsnBack(f.clci_ssn_back)) missing.push('주민번호 뒷자리(7자리)');
  if (!f.clci_job_type) missing.push('직종');
  if (!f.clci_phone.trim()) missing.push('휴대폰');
  if (!f.clci_work_start_date) missing.push('입사일');
  return missing;
};

const formatSsnFront = (birthDate: string) => {
  const d = formatDate(birthDate);
  if (!d || d === '-') return '******';
  const yymmdd = d.replace(/-/g, '').slice(2);
  return yymmdd.length === 6 ? yymmdd : '******';
};

const beneficiarySsnFront = (item: { clsr_ssn_front?: string | null; clsr_birth_date?: string | null }) => {
  const stored = String(item?.clsr_ssn_front || '').replace(/\D/g, '');
  if (stored.length === 6) return stored;
  return formatSsnFront(item?.clsr_birth_date || '');
};

const isBeneficiarySsnMissing = (item: { clsr_has_ssn_back?: boolean }) => !item?.clsr_has_ssn_back;

const saveNewEmployee = async () => {
  if (employeeSaving.value) return;

  // 날짜 입력 중(한 자리 월·일)이면 blur로 패딩·modelValue 반영
  const active = document.activeElement as HTMLElement | null;
  if (active && typeof active.blur === 'function') active.blur();
  await nextTick();

  if (!memberCode.value) {
    alert('시설 정보를 확인할 수 없습니다. 페이지를 새로고침한 뒤 다시 시도해 주세요.');
    return;
  }

  const rows = newEmployeeRows.value;
  const issues: string[] = [];
  for (let i = 0; i < rows.length; i++) {
    const missing = getEmployeeRowMissingFields(rows[i]);
    if (missing.length) {
      issues.push(`${i + 1}행: ${missing.join(', ')}`);
    }
  }
  if (issues.length) {
    alert(`다음 항목을 입력해 주세요.\n· ${issues.join('\n· ')}`);
    return;
  }

  // 배치 내 중복 체크
  const seenKeys = new Set<string>();
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const key = `${r.clci_name.trim()}|${r.clci_birth_date}|${r.clci_work_start_date}`;
    if (seenKeys.has(key)) {
      alert(`${i + 1}행: 입력 목록에 동일한 사원(성명·생년월일·입사일)이 있습니다.`);
      return;
    }
    seenKeys.add(key);
  }

  // 기존 목록 중복 체크
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const dup = findEmployeeDuplicate(employeeList.value, {
      clci_name: r.clci_name.trim(),
      clci_birth_date: r.clci_birth_date,
      clci_work_start_date: r.clci_work_start_date,
    });
    if (dup) {
      alert(`${i + 1}행: ${DUPLICATE_EMPLOYEE_MESSAGE}`);
      return;
    }
  }

  employeeSaving.value = true;
  let successCount = 0;
  try {
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const ssnDigits = r.clci_ssn_back.replace(/\D/g, '');
      const email = r.clci_email.trim();
      try {
        await employeeApi.create(memberCode.value, {
          clci_name: r.clci_name.trim(),
          clci_birth_date: r.clci_birth_date,
          clci_ssn_back: ssnDigits,
          clci_job_type: r.clci_job_type,
          clci_work_start_date: r.clci_work_start_date,
          clci_phone: r.clci_phone.trim(),
          ...(email ? { clci_email: email } : {}),
        });
        successCount += 1;
      } catch (error: any) {
        const message = error.response?.data?.message || error.message || '등록에 실패했습니다.';
        const remain = rows.length - i;
        alert(
          `${i + 1}행(${r.clci_name.trim() || '이름없음'}) 등록 실패: ${message}` +
            `${error.response?.status ? ` (${error.response.status})` : ''}` +
            (successCount ? `\n\n이미 ${successCount}명은 등록되었습니다.` : '') +
            (remain > 1 ? `\n남은 ${remain - 1}명은 등록되지 않았습니다.` : '')
        );
        await loadEmployeeList();
        // 실패한 행부터 남김
        newEmployeeRows.value = rows.slice(i).map((row) => ({ ...row, _key: employeeQuickRowSeq++ }));
        return;
      }
    }
    resetEmployeeQuickRows();
    showEmployeeQuickAdd.value = false;
    await loadEmployeeList();
    if (successCount > 1) {
      alert(`${successCount}명 등록이 완료되었습니다.`);
    }
  } finally {
    employeeSaving.value = false;
  }
};

const filteredEmployeeList = computed(() => {
  let result = [...employeeList.value];
  if (employeeStatusFilter.value === '현원') {
    result = result.filter((r) => r.month_status === '현원');
  } else if (employeeStatusFilter.value === '퇴사') {
    result = result.filter((r) => r.month_status === '퇴사');
  } else if (employeeStatusFilter.value === '주민번호미등록') {
    result = result.filter((r) => isEmployeeSsnMissing(r));
  } else if (employeeStatusFilter.value === '앱연동') {
    result = result.filter((r) => isEmployeeAppLinked(r));
  }
  if (employeeSearchText.value) {
    const keyword = employeeSearchText.value.toLowerCase();
    result = result.filter(
      (r) =>
        r.clci_name?.toLowerCase().includes(keyword) ||
        r.clci_job_type?.toLowerCase().includes(keyword)
    );
  }

  const sortKey = employeeSortKey.value;
  const sortOrder = employeeSortOrder.value;
  result.sort((a, b) => {
    if (a.is_duplicate !== b.is_duplicate) {
      return a.is_duplicate ? -1 : 1;
    }
    if (!sortKey) return 0;
    if (sortKey === 'app_linked') {
      const rank = (row: any) => (isEmployeeAppLinked(row) ? 1 : 0);
      const diff = rank(a) - rank(b);
      if (diff !== 0) return sortOrder === 'asc' ? diff : -diff;
      const aLabel = String(a.app_link_label || '');
      const bLabel = String(b.app_link_label || '');
      if (aLabel === bLabel) return 0;
      const cmp = aLabel.localeCompare(bLabel, 'ko');
      return sortOrder === 'asc' ? cmp : -cmp;
    }
    let aVal: string | number = a[sortKey];
    let bVal: string | number = b[sortKey];
    if (aVal == null) aVal = '';
    if (bVal == null) bVal = '';
    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();
    if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  return result;
});

const toggleEmployeeSort = (key: string) => {
  if (employeeSortKey.value === key) {
    employeeSortOrder.value = employeeSortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    employeeSortKey.value = key;
    employeeSortOrder.value = 'asc';
  }
};

const getEmployeeSortIcon = (key: string) => {
  if (employeeSortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return employeeSortOrder.value === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down';
};

const loadEmployeeList = async () => {
  if (!memberCode.value) return;
  employeeLoading.value = true;
  try {
    const res = await employeeApi.getList(memberCode.value, {
      yearMonth: selectedYearMonth.value,
      groupSamePerson: true,
      limit: 2000,
    });
    const data = res.data?.data;
    employeeList.value = data?.list || [];
    if (data?.stats) {
      employeeStats.value = {
        total: data.stats.total ?? 0,
        hyunwon: data.stats.hyunwon ?? 0,
        toesaw: data.stats.toesaw ?? 0,
        monthEnter: data.stats.monthEnter ?? 0,
        monthLeave: data.stats.monthLeave ?? 0,
      };
    }
    if (data?.meta) {
      employeeMeta.value = {
        lastAutoCollectWdate: data.meta.lastAutoCollectWdate ?? null,
        yearMonth: data.meta.yearMonth,
      };
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`사원 목록 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
    employeeList.value = [];
  } finally {
    employeeLoading.value = false;
  }
};

const startEmployeeSsnEdit = () => {
  employeeSsnEditing.value = true;
  ssnRevealed.value = false;
  employeeEditForm.value.clci_ssn_back = '';
};

const cancelEmployeeSsnEdit = () => {
  employeeSsnEditing.value = false;
  employeeEditForm.value.clci_ssn_back = '';
};

const openEmployeeDetail = (item: any) => {
  selectedEmployee.value = item;
  ssnRevealed.value = false;
  ssnRevealedValue.value = '';
  employeeSsnEditing.value = false;
  const birth = formatDate(item.clci_birth_date) === '-' ? '' : formatDate(item.clci_birth_date);
  employeeEditForm.value = {
    clci_name: item.clci_name || '',
    clci_birth_ymd: ymd8FromBirthDate(birth),
    clci_birth_date: birth,
    clci_ssn_back: '',
    clci_job_type: item.clci_job_type || '',
    clci_work_start_date: formatDate(item.clci_work_start_date) === '-' ? '' : formatDate(item.clci_work_start_date),
    clci_work_end_date: formatDate(item.clci_work_end_date) === '-' ? '' : formatDate(item.clci_work_end_date),
    clci_phone: item.clci_phone || '',
    clci_email: item.clci_email || '',
    clci_zipcode: item.clci_zipcode || '',
    clci_addr1: item.clci_addr1 || '',
    clci_addr2: item.clci_addr2 || '',
  };
  employeeDetailDialog.value = true;
};

const closeEmployeeDetail = () => {
  employeeDetailDialog.value = false;
  selectedEmployee.value = null;
  ssnRevealed.value = false;
  ssnRevealedValue.value = '';
  employeeSsnEditing.value = false;
};

/** 앱 회원정보와 맞춘 뒤 상세 폼의 같은 항목을 서버 값으로 다시 채운다 */
const onEmployeeProfileLinked = async () => {
  const current = selectedEmployee.value;
  if (!current?.clci_idx) return;
  const source = current.clci_source === 'manual' ? 'manual' : 'auto';
  try {
    const res = await employeeApi.getById(
      memberCode.value,
      source,
      current.clci_idx,
      selectedYearMonth.value
    );
    const row = res.data?.data;
    if (!row || !employeeDetailDialog.value) return;
    const birth = formatDate(row.clci_birth_date) === '-' ? '' : formatDate(row.clci_birth_date);
    employeeEditForm.value.clci_name = row.clci_name || '';
    employeeEditForm.value.clci_birth_ymd = ymd8FromBirthDate(birth);
    employeeEditForm.value.clci_birth_date = birth;
    employeeEditForm.value.clci_phone = row.clci_phone || '';
    employeeEditForm.value.clci_email = row.clci_email || '';
    employeeEditForm.value.clci_zipcode = row.clci_zipcode || '';
    employeeEditForm.value.clci_addr1 = row.clci_addr1 || '';
    employeeEditForm.value.clci_addr2 = row.clci_addr2 || '';
    selectedEmployee.value = { ...current, ...row, clci_source: source };
    await loadEmployeeList();
  } catch {
    /* 목록을 다시 열면 반영된다 */
  }
};

const revealEmployeeSsn = async () => {
  if (!selectedEmployee.value || !memberCode.value || ssnRevealing.value) return;

  if (ssnRevealed.value) {
    ssnRevealed.value = false;
    ssnRevealedValue.value = '';
    return;
  }

  const source = selectedEmployee.value.clci_source === 'manual' ? 'manual' : 'auto';
  ssnRevealing.value = true;
  try {
    const res = await employeeApi.revealSsn(memberCode.value, source, selectedEmployee.value.clci_idx);
    const plain = res.data?.data?.clci_ssn_back;
    if (!plain) {
      alert('저장된 주민번호 뒷자리가 없습니다.');
      return;
    }
    ssnRevealedValue.value = plain;
    ssnRevealed.value = true;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '조회에 실패했습니다.';
    alert(`주민번호 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    ssnRevealing.value = false;
  }
};

const saveEmployeeEdit = async () => {
  if (!selectedEmployee.value || employeeSaving.value || !memberCode.value) return;

  const birthDate = birthDateFromYmd8(employeeEditForm.value.clci_birth_ymd);
  if (!birthDate) {
    alert('생년월일은 숫자 8자리(YYYYMMDD)여야 합니다.');
    return;
  }
  employeeEditForm.value.clci_birth_date = birthDate;

  if (!employeeEditForm.value.clci_work_start_date) {
    alert('입사일을 입력해 주세요.');
    return;
  }

  const ssnInput = employeeEditForm.value.clci_ssn_back.replace(/\D/g, '');
  if (ssnInput && !isValidSsnBack(ssnInput)) {
    alert('주민번호 뒷자리는 숫자 7자리여야 합니다.');
    return;
  }

  const excludeId = getEmployeeRowIdentity(selectedEmployee.value);
  const dup = findEmployeeDuplicate(
    employeeList.value,
    {
      clci_name: employeeEditForm.value.clci_name.trim(),
      clci_birth_date: employeeEditForm.value.clci_birth_date,
      clci_work_start_date: employeeEditForm.value.clci_work_start_date,
    },
    excludeId
  );
  if (dup) {
    alert(DUPLICATE_EMPLOYEE_MESSAGE);
    return;
  }

  const source = selectedEmployee.value.clci_source === 'manual' ? 'manual' : 'auto';
  const payload: Record<string, unknown> = {
    clci_name: employeeEditForm.value.clci_name.trim(),
    clci_birth_date: employeeEditForm.value.clci_birth_date,
    clci_job_type: employeeEditForm.value.clci_job_type || null,
    clci_work_start_date: employeeEditForm.value.clci_work_start_date,
    clci_work_end_date: employeeEditForm.value.clci_work_end_date || null,
    clci_phone: employeeEditForm.value.clci_phone || null,
    clci_email: employeeEditForm.value.clci_email || null,
    clci_zipcode: employeeEditForm.value.clci_zipcode || null,
    clci_addr1: employeeEditForm.value.clci_addr1 || null,
    clci_addr2: employeeEditForm.value.clci_addr2 || null,
  };
  if (ssnInput) {
    payload.clci_ssn_back = ssnInput;
  }

  employeeSaving.value = true;
  try {
    await employeeApi.update(
      memberCode.value,
      selectedEmployee.value.clci_idx,
      payload,
      source
    );
    closeEmployeeDetail();
    await loadEmployeeList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '수정에 실패했습니다.';
    alert(`사원 수정 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    employeeSaving.value = false;
  }
};

const deleteEmployee = async () => {
  if (
    !selectedEmployee.value ||
    selectedEmployee.value.clci_source !== 'manual' ||
    employeeDeleting.value ||
    !memberCode.value
  ) {
    return;
  }
  if (!confirm(`「${selectedEmployee.value.clci_name}」 사원을 삭제하시겠습니까?`)) return;
  employeeDeleting.value = true;
  try {
    await employeeApi.delete(memberCode.value, selectedEmployee.value.clci_idx);
    closeEmployeeDetail();
    await loadEmployeeList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '삭제에 실패했습니다.';
    alert(`사원 삭제 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    employeeDeleting.value = false;
  }
};

// ── 수급자 (LTCS 자동수집 + 직접등록 UNION) ──
const beneficiaryLoading = ref(false);
const beneficiarySaving = ref(false);
const beneficiaryDeleting = ref(false);
const beneficiaryList = ref<any[]>([]);
const beneficiaryStats = ref({
  total: 0,
  ipso: 0,
  toiso: 0,
  monthEnter: 0,
  monthLeave: 0,
});
const beneficiaryMeta = ref<{ lastAutoCollectWdate?: string | null; yearMonth?: string }>({});
const beneficiaryStatusFilter = ref('');
const beneficiarySearchText = ref('');
const beneficiarySortKey = ref('clsr_recipient_name');
const beneficiarySortOrder = ref<'asc' | 'desc'>('asc');
const showBeneficiaryQuickAdd = ref(false);
const beneficiaryDetailDialog = ref(false);
const selectedBeneficiary = ref<any>(null);

const beneficiaryEditForm = ref({
  clsr_recipient_name: '',
  clsr_approval_no: '',
  clsr_birth_date: '',
  clsr_ssn_front: '',
  clsr_ssn_back: '',
  clsr_grade: '',
  clsr_service_type: '',
  clsr_enter_date: '',
  clsr_leave_date: '',
  clsr_phone: '',
  clsr_zipcode: '',
  clsr_addr1: '',
  clsr_addr2: '',
});
const beneficiaryHistory = ref<any[]>([]);
const beneficiaryHistoryLoading = ref(false);
const beneficiaryStayActing = ref(false);
const stayLeaveDate = ref('');
const reenterDate = ref('');
const reenterGrade = ref('');
const beneficiaryDetailTab = ref<'info' | 'history'>('info');
const beneficiaryOriginal = ref({ grade: '', enter: '', leave: '' });

const todayYmd = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

const beneficiarySavedLeave = computed(() => toDateOnly(beneficiaryOriginal.value.leave));
const beneficiaryHasLeft = computed(() => {
  const leave = beneficiarySavedLeave.value;
  return !!leave && leave !== '0000-00-00' && leave < todayYmd();
});

const formatDotDate = (value: string | null | undefined) => {
  const date = toDateOnly(value);
  return date ? date.replace(/-/g, '.') : '';
};

const beneficiaryStayHeadline = computed(() => {
  if (beneficiaryHasLeft.value) return '퇴소했습니다';
  if (beneficiaryOriginal.value.enter || beneficiarySavedLeave.value) return '입소 중입니다';
  return '입소일이 없습니다';
});

const beneficiaryStayDetail = computed(() => {
  const enter = formatDotDate(beneficiaryOriginal.value.enter);
  const leave = formatDotDate(beneficiarySavedLeave.value);
  const grade = beneficiaryOriginal.value.grade;
  if (!enter && !leave) return '입소일을 입력한 뒤 저장하세요.';
  const parts = [`입소 ${enter || '없음'}`];
  if (leave) parts.push(beneficiaryHasLeft.value ? `퇴소 ${leave}` : `퇴소 예정 ${leave}`);
  if (grade) parts.push(grade);
  return parts.join(' · ');
});

const isBeneficiaryReenter = (item: { past_stay_count?: number; month_status?: string }) =>
  Number(item?.past_stay_count || 0) > 0 && item?.month_status === '입소';

const historyItemTitle = (item: any) => {
  if (item.clrh_kind === 'grade') {
    const when = formatDotDate(item.clrh_effective_date) || '날짜 없음';
    return `${when} 등급 ${item.clrh_prev_grade || '없음'} → ${item.clrh_grade || '없음'}`;
  }
  const enter = formatDotDate(item.clrh_enter_date) || '입소일 없음';
  const leave = formatDotDate(item.clrh_leave_date) || '퇴소일 없음';
  return `${enter} – ${leave}`;
};

const historyItemMeta = (item: any) => {
  if (item.clrh_kind === 'grade') return '등급 변경';
  return item.clrh_grade ? `지난 이용 · ${item.clrh_grade}` : '지난 이용';
};

const benSsnRevealing = ref(false);
const benSsnRevealed = ref(false);
const benSsnRevealedValue = ref('');
const beneficiarySsnEditing = ref(false);

const filteredBeneficiaryList = computed(() => {
  let result = [...beneficiaryList.value];
  if (beneficiaryStatusFilter.value === '입소') {
    result = result.filter((r) => r.month_status === '입소');
  } else if (beneficiaryStatusFilter.value === '퇴소') {
    result = result.filter((r) => r.month_status === '퇴소');
  }
  if (beneficiarySearchText.value) {
    const keyword = beneficiarySearchText.value.toLowerCase();
    result = result.filter(
      (r) =>
        r.clsr_recipient_name?.toLowerCase().includes(keyword) ||
        r.clsr_approval_no?.toLowerCase().includes(keyword) ||
        r.clsr_phone?.includes(keyword)
    );
  }
  if (beneficiarySortKey.value) {
    result.sort((a, b) => {
      let aVal: string | number = a[beneficiarySortKey.value];
      let bVal: string | number = b[beneficiarySortKey.value];
      if (aVal == null) aVal = '';
      if (bVal == null) bVal = '';
      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();
      if (aVal < bVal) return beneficiarySortOrder.value === 'asc' ? -1 : 1;
      if (aVal > bVal) return beneficiarySortOrder.value === 'asc' ? 1 : -1;
      return 0;
    });
  }
  return result;
});

const toggleBeneficiarySort = (key: string) => {
  if (beneficiarySortKey.value === key) {
    beneficiarySortOrder.value = beneficiarySortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    beneficiarySortKey.value = key;
    beneficiarySortOrder.value = 'asc';
  }
};

const getBeneficiarySortIcon = (key: string) => {
  if (beneficiarySortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return beneficiarySortOrder.value === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down';
};

const loadBeneficiaryList = async () => {
  if (!memberCode.value) return;
  beneficiaryLoading.value = true;
  try {
    const res = await beneficiaryApi.getList(memberCode.value, {
      yearMonth: selectedYearMonth.value,
      limit: 2000,
    });
    const data = res.data?.data;
    beneficiaryList.value = data?.list || [];
    if (data?.stats) {
      beneficiaryStats.value = {
        total: data.stats.total ?? 0,
        ipso: data.stats.ipso ?? 0,
        toiso: data.stats.toiso ?? 0,
        monthEnter: data.stats.monthEnter ?? 0,
        monthLeave: data.stats.monthLeave ?? 0,
      };
    }
    if (data?.meta) {
      beneficiaryMeta.value = {
        lastAutoCollectWdate: data.meta.lastAutoCollectWdate ?? null,
        yearMonth: data.meta.yearMonth,
      };
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`수급자 목록 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
    beneficiaryList.value = [];
  } finally {
    beneficiaryLoading.value = false;
  }
};

const startBeneficiarySsnEdit = () => {
  beneficiarySsnEditing.value = true;
  benSsnRevealed.value = false;
  beneficiaryEditForm.value.clsr_ssn_back = '';
};

const cancelBeneficiarySsnEdit = () => {
  beneficiarySsnEditing.value = false;
  beneficiaryEditForm.value.clsr_ssn_back = '';
};

const openBeneficiaryDetail = (item: any) => {
  selectedBeneficiary.value = item;
  benSsnRevealed.value = false;
  benSsnRevealedValue.value = '';
  beneficiarySsnEditing.value = false;
  const birth = formatDate(item.clsr_birth_date) === '-' ? '' : formatDate(item.clsr_birth_date);
  const ssnFrontDerived = formatSsnFront(birth);
  beneficiaryEditForm.value = {
    clsr_recipient_name: item.clsr_recipient_name || '',
    clsr_approval_no: item.clsr_approval_no || '',
    clsr_birth_date: birth,
    clsr_ssn_front: item.clsr_ssn_front || (ssnFrontDerived !== '******' ? ssnFrontDerived : ''),
    clsr_ssn_back: '',
    clsr_grade: item.clsr_grade || '',
    clsr_service_type: item.clsr_service_type || '',
    clsr_enter_date: formatDate(item.clsr_enter_date) === '-' ? '' : formatDate(item.clsr_enter_date),
    clsr_leave_date: formatDate(item.clsr_leave_date) === '-' ? '' : formatDate(item.clsr_leave_date),
    clsr_phone: item.clsr_phone || '',
    clsr_zipcode: item.clsr_zipcode || '',
    clsr_addr1: item.clsr_addr1 || '',
    clsr_addr2: item.clsr_addr2 || '',
  };
  beneficiaryDetailTab.value = 'info';
  syncBeneficiaryStayDraft();
  beneficiaryDetailDialog.value = true;
  loadBeneficiaryHistory();
};

const syncBeneficiaryStayDraft = () => {
  beneficiaryOriginal.value = {
    grade: beneficiaryEditForm.value.clsr_grade.trim(),
    enter: beneficiaryEditForm.value.clsr_enter_date,
    leave: beneficiaryEditForm.value.clsr_leave_date,
  };
  stayLeaveDate.value = todayYmd();
  reenterDate.value = todayYmd();
  reenterGrade.value = beneficiaryEditForm.value.clsr_grade;
};

const loadBeneficiaryHistory = async () => {
  if (!selectedBeneficiary.value || !memberCode.value) {
    beneficiaryHistory.value = [];
    return;
  }
  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  beneficiaryHistoryLoading.value = true;
  try {
    const res = await beneficiaryApi.getHistory(
      memberCode.value,
      source,
      selectedBeneficiary.value.clsr_idx
    );
    beneficiaryHistory.value = res.data?.data || [];
  } catch {
    beneficiaryHistory.value = [];
  } finally {
    beneficiaryHistoryLoading.value = false;
  }
};

const closeBeneficiaryDetail = () => {
  beneficiaryDetailDialog.value = false;
  beneficiaryDetailTab.value = 'info';
  selectedBeneficiary.value = null;
  beneficiaryHistory.value = [];
  benSsnRevealed.value = false;
  benSsnRevealedValue.value = '';
  beneficiarySsnEditing.value = false;
};

// 생년월일이 바뀌면 주민번호 앞자리가 비어 있을 때 자동 채움
watch(
  () => beneficiaryEditForm.value.clsr_birth_date,
  (birth) => {
    if (beneficiaryEditForm.value.clsr_ssn_front) return;
    const derived = formatSsnFront(birth);
    if (derived !== '******') {
      beneficiaryEditForm.value.clsr_ssn_front = derived;
    }
  }
);

const revealBeneficiarySsn = async () => {
  if (!selectedBeneficiary.value || !memberCode.value || benSsnRevealing.value) return;

  if (benSsnRevealed.value) {
    benSsnRevealed.value = false;
    benSsnRevealedValue.value = '';
    return;
  }

  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  benSsnRevealing.value = true;
  try {
    const res = await beneficiaryApi.revealSsn(memberCode.value, source, selectedBeneficiary.value.clsr_idx);
    const plain = res.data?.data?.clsr_ssn_back;
    if (!plain) {
      alert('저장된 주민번호 뒷자리가 없습니다.');
      return;
    }
    benSsnRevealedValue.value = plain;
    benSsnRevealed.value = true;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '조회에 실패했습니다.';
    alert(`주민번호 조회 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    benSsnRevealing.value = false;
  }
};

const saveBeneficiaryEdit = async () => {
  if (!selectedBeneficiary.value || beneficiarySaving.value || !memberCode.value) return;

  const ssnFront = beneficiaryEditForm.value.clsr_ssn_front.replace(/\D/g, '');
  if (ssnFront && ssnFront.length !== 6) {
    alert('주민번호 앞자리는 숫자 6자리여야 합니다.');
    return;
  }
  const ssnBack = beneficiaryEditForm.value.clsr_ssn_back.replace(/\D/g, '');
  if (ssnBack && !isValidSsnBack(ssnBack)) {
    alert('주민번호 뒷자리는 숫자 7자리여야 합니다.');
    return;
  }

  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  const payload: Record<string, unknown> = {
    clsr_recipient_name: beneficiaryEditForm.value.clsr_recipient_name.trim(),
    clsr_approval_no: beneficiaryEditForm.value.clsr_approval_no || null,
    clsr_birth_date: beneficiaryEditForm.value.clsr_birth_date || null,
    clsr_grade: beneficiaryEditForm.value.clsr_grade || null,
    clsr_service_type: beneficiaryEditForm.value.clsr_service_type || null,
    clsr_enter_date: beneficiaryEditForm.value.clsr_enter_date || null,
    clsr_leave_date: beneficiaryEditForm.value.clsr_leave_date || null,
    clsr_phone: beneficiaryEditForm.value.clsr_phone || null,
    clsr_zipcode: beneficiaryEditForm.value.clsr_zipcode || null,
    clsr_addr1: beneficiaryEditForm.value.clsr_addr1 || null,
    clsr_addr2: beneficiaryEditForm.value.clsr_addr2 || null,
    clsr_ssn_front: ssnFront || null,
  };
  if (ssnBack) {
    payload.clsr_ssn_back = ssnBack;
  }

  beneficiarySaving.value = true;
  try {
    await beneficiaryApi.updateLtcsInfo(memberCode.value, source, selectedBeneficiary.value.clsr_idx, payload);
    closeBeneficiaryDetail();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '수정에 실패했습니다.';
    alert(`수급자 수정 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiarySaving.value = false;
  }
};

const patchBeneficiaryStay = async (payload: Record<string, unknown>) => {
  if (!selectedBeneficiary.value || !memberCode.value) return;
  const source = selectedBeneficiary.value.clsr_source === 'manual' ? 'manual' : 'auto';
  const clsrIdx = selectedBeneficiary.value.clsr_idx;
  beneficiaryStayActing.value = true;
  try {
    await beneficiaryApi.updateLtcsInfo(memberCode.value, source, clsrIdx, payload);
    const res = await beneficiaryApi.getLtcsById(memberCode.value, source, clsrIdx);
    const row = res.data?.data;
    if (row) {
      selectedBeneficiary.value = { ...selectedBeneficiary.value, ...row };
      const enter = formatDate(row.clsr_enter_date);
      const leave = formatDate(row.clsr_leave_date);
      beneficiaryEditForm.value.clsr_enter_date = enter === '-' ? '' : enter;
      beneficiaryEditForm.value.clsr_leave_date = leave === '-' ? '' : leave;
      beneficiaryEditForm.value.clsr_grade = row.clsr_grade || '';
      syncBeneficiaryStayDraft();
    }
    await loadBeneficiaryHistory();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '기록에 실패했습니다.';
    alert(message);
  } finally {
    beneficiaryStayActing.value = false;
  }
};

const recordBeneficiaryLeave = async () => {
  if (!selectedBeneficiary.value || beneficiaryStayActing.value) return;
  const leave = stayLeaveDate.value;
  if (!leave) {
    alert('퇴소일을 입력하세요.');
    return;
  }
  const enter = beneficiaryOriginal.value.enter;
  if (enter && leave < enter) {
    alert('퇴소일은 입소일 이후여야 합니다.');
    return;
  }
  if (!confirm(`${formatDotDate(leave)}로 퇴소 처리합니다.\n입소일과 등급은 유지됩니다.`)) return;
  await patchBeneficiaryStay({ clsr_leave_date: leave });
};

const recordBeneficiaryReenter = async () => {
  if (!selectedBeneficiary.value || beneficiaryStayActing.value) return;
  const enter = reenterDate.value;
  if (!enter) {
    alert('새 입소일을 입력하세요.');
    return;
  }
  const oldLeave = beneficiaryOriginal.value.leave;
  const oldEnter = beneficiaryOriginal.value.enter;
  if (oldLeave && enter < oldLeave) {
    alert('다시 입소일은 퇴소일 이후여야 합니다.');
    return;
  }
  if (oldEnter && enter === oldEnter) {
    alert('새 입소일은 지난 입소일과 달라야 합니다.');
    return;
  }
  const grade = reenterGrade.value.trim();
  const period = `${formatDotDate(oldEnter) || '입소일 없음'} ~ ${formatDotDate(oldLeave)}`;
  const gradeNote = beneficiaryOriginal.value.grade ? `, ${beneficiaryOriginal.value.grade}` : '';
  if (!confirm(`${formatDotDate(enter)}부터 다시 입소로 기록합니다.\n지난 이용(${period}${gradeNote})은 이력에 남습니다.`)) return;
  await patchBeneficiaryStay({
    clsr_enter_date: enter,
    clsr_leave_date: null,
    clsr_grade: grade || null,
  });
};

const deleteBeneficiary = async () => {
  if (
    !selectedBeneficiary.value ||
    selectedBeneficiary.value.clsr_source !== 'manual' ||
    beneficiaryDeleting.value ||
    !memberCode.value
  ) return;
  if (!confirm(`「${selectedBeneficiary.value.clsr_recipient_name}」 수급자를 삭제하시겠습니까?`)) return;
  beneficiaryDeleting.value = true;
  try {
    await beneficiaryApi.deleteLtcsManual(memberCode.value, selectedBeneficiary.value.clsr_idx);
    closeBeneficiaryDetail();
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '삭제에 실패했습니다.';
    alert(`수급자 삭제 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiaryDeleting.value = false;
  }
};

const newBeneficiaryForm = ref({
  clsr_recipient_name: '',
  clsr_approval_no: '',
  clsr_birth_date: '',
  clsr_service_type: '',
  clsr_enter_date: '',
  clsr_phone: '',
});

const isValidRecipientId = (value: string) => {
  if (!value || value === 'L') return true;
  return /^L\d{10}$/.test(value);
};

const onRecipientIdFocus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (!input.value) input.value = 'L';
  setTimeout(() => input.setSelectionRange(input.value.length, input.value.length), 0);
};

const onRecipientIdBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (input.value === 'L') {
    input.value = '';
    newBeneficiaryForm.value.clsr_approval_no = '';
  }
};

const onRecipientIdInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.toUpperCase();
  if (value.length > 0 && value[0] !== 'L') {
    value = /^\d/.test(value) ? `L${value}` : `L${value.slice(1)}`;
  }
  if (!value) value = 'L';
  if (value.length > 1) value = `L${value.slice(1).replace(/\D/g, '')}`;
  value = value.slice(0, 11);
  input.value = value;
  newBeneficiaryForm.value.clsr_approval_no = value === 'L' ? '' : value;
};

const canSaveNew = computed(() => {
  const nameValid = !!newBeneficiaryForm.value.clsr_recipient_name.trim();
  const birthValid = !!newBeneficiaryForm.value.clsr_birth_date;
  const approvalValid =
    !newBeneficiaryForm.value.clsr_approval_no ||
    isValidRecipientId(newBeneficiaryForm.value.clsr_approval_no);
  return nameValid && birthValid && approvalValid;
});

const saveNewBeneficiary = async () => {
  if (!canSaveNew.value || beneficiarySaving.value || !memberCode.value) return;
  beneficiarySaving.value = true;
  try {
    await beneficiaryApi.create(memberCode.value, {
      useLtcs: true,
      clsr_recipient_name: newBeneficiaryForm.value.clsr_recipient_name.trim(),
      clsr_birth_date: newBeneficiaryForm.value.clsr_birth_date,
      clsr_approval_no: newBeneficiaryForm.value.clsr_approval_no || undefined,
      clsr_service_type: newBeneficiaryForm.value.clsr_service_type || undefined,
      clsr_enter_date: newBeneficiaryForm.value.clsr_enter_date || undefined,
      clsr_phone: newBeneficiaryForm.value.clsr_phone || undefined,
    });
    newBeneficiaryForm.value = {
      clsr_recipient_name: '',
      clsr_approval_no: '',
      clsr_birth_date: '',
      clsr_service_type: '',
      clsr_enter_date: '',
      clsr_phone: '',
    };
    showBeneficiaryQuickAdd.value = false;
    await loadBeneficiaryList();
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '등록에 실패했습니다.';
    alert(`수급자 등록 실패: ${message}${error.response?.status ? ` (${error.response.status})` : ''}`);
  } finally {
    beneficiarySaving.value = false;
  }
};

// ── 수급자 엑셀 업로드 (인사관리 + 회계 동시 반영) ──
const beneficiaryExcelModal = ref(false);
const beneficiaryExcelInputRef = ref<HTMLInputElement | null>(null);
const beneficiaryExcelFile = ref<File | null>(null);
const beneficiaryExcelFileName = ref('');
const beneficiaryExcelUploading = ref(false);
const beneficiaryExcelMessage = ref('');
const beneficiaryExcelError = ref(false);

const openBeneficiaryExcelModal = () => {
  beneficiaryExcelFile.value = null;
  beneficiaryExcelFileName.value = '';
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  beneficiaryExcelModal.value = true;
};

const closeBeneficiaryExcelModal = () => {
  if (beneficiaryExcelUploading.value) return;
  beneficiaryExcelModal.value = false;
};

const downloadBeneficiaryTemplate = async () => {
  try {
    await beneficiaryApi.downloadTemplate();
  } catch (error: any) {
    alert(error.response?.data?.message || error.message || '양식 다운로드 실패');
  }
};

const onBeneficiaryExcelSelected = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0] || null;
  beneficiaryExcelFile.value = file;
  beneficiaryExcelFileName.value = file?.name || '';
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  if (input) input.value = '';
};

const uploadBeneficiaryExcel = async () => {
  if (!beneficiaryExcelFile.value || !memberCode.value || beneficiaryExcelUploading.value) return;
  beneficiaryExcelUploading.value = true;
  beneficiaryExcelMessage.value = '';
  beneficiaryExcelError.value = false;
  try {
    const formData = new FormData();
    formData.append('file', beneficiaryExcelFile.value);
    const res = await beneficiaryApi.bulkCreate(memberCode.value, formData);
    const msg = res.data?.message || '업로드가 완료되었습니다.';
    beneficiaryExcelMessage.value = msg;
    beneficiaryExcelError.value = false;
    await loadBeneficiaryList();
    alert(msg);
    beneficiaryExcelModal.value = false;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '업로드에 실패했습니다.';
    beneficiaryExcelMessage.value = message;
    beneficiaryExcelError.value = true;
  } finally {
    beneficiaryExcelUploading.value = false;
  }
};

// ── 공통 ──
const avatarColors = [
  '#1e3a5f', '#2e7d32', '#c62828', '#f57c00', '#6a1b9a',
  '#00838f', '#4527a0', '#ad1457', '#00695c', '#bf360c'
];

const getAvatarColor = (name: string) => {
  if (!name) return '#90a4ae';
  return avatarColors[name.charCodeAt(0) % avatarColors.length];
};

const getInitial = (name: string) => (name ? name.charAt(0) : '?');

const formatDate = (dateStr: string | null) => {
  if (!dateStr) return '-';
  return dateStr.split('T')[0];
};

type EmploymentLine = {
  clci_source?: string;
  clci_source_label?: string;
  clci_idx?: number;
  clci_work_start_date?: string | null;
  clci_work_end_date?: string | null;
  clci_wdate?: string | null;
  clci_rdate?: string | null;
  month_status?: string | null;
};

const employmentLines = (item: any): EmploymentLine[] => {
  const lines = Array.isArray(item?.employments) ? item.employments : [];
  if (lines.length) return lines;
  return [{
    clci_source: item?.clci_source === 'manual' ? 'manual' : 'auto',
    clci_source_label: item?.clci_source_label || (item?.clci_source === 'manual' ? '직접등록' : '자동수집'),
    clci_idx: item?.clci_idx,
    clci_work_start_date: item?.clci_work_start_date,
    clci_work_end_date: item?.clci_work_end_date,
    clci_wdate: item?.clci_wdate,
    clci_rdate: item?.clci_rdate,
  }];
};

const hasSeveralEmployments = (item: any) => employmentLines(item).length > 1;

const employmentSourceLabel = (source?: string) => (source === 'manual' ? '직접등록' : '자동수집');

/** 임금·증명서에 쓰는 입사일. 직접등록 입사일이 있으면 그 기록 */
const wageEmployment = (item: any): EmploymentLine | null => {
  const lines = employmentLines(item);
  const dated = lines.filter((line) => toDateOnly(line.clci_work_start_date));
  const manuals = dated.filter((line) => line.clci_source === 'manual');
  const pool = manuals.length ? manuals : (dated.length ? dated : lines);
  return [...pool].sort((a, b) => {
    const aOpen = a.month_status === '현원' || (!a.month_status && !leaveDateOf(a)) ? 0 : 1;
    const bOpen = b.month_status === '현원' || (!b.month_status && !leaveDateOf(b)) ? 0 : 1;
    if (aOpen !== bOpen) return aOpen - bOpen;
    return toDateOnly(b.clci_work_start_date).localeCompare(toDateOnly(a.clci_work_start_date));
  })[0] || null;
};

const shownEmployment = (item: any): EmploymentLine | null => wageEmployment(item);

const otherJoinLines = (item: any): EmploymentLine[] => {
  const picked = shownEmployment(item);
  const used = toDateOnly(picked?.clci_work_start_date);
  return employmentLines(item).filter((line) => {
    if (picked && line.clci_source === picked.clci_source && Number(line.clci_idx) === Number(picked.clci_idx)) {
      return false;
    }
    const start = toDateOnly(line.clci_work_start_date);
    return !!start && start !== used;
  });
};

const otherJoinCaption = (item: any, line: EmploymentLine) => {
  const word = line.clci_source === 'manual' ? '직접' : '수집';
  const full = formatDate(line.clci_work_start_date);
  const base = formatDate(shownEmployment(item)?.clci_work_start_date);
  const shown = full !== '-' && base !== '-' && full.slice(0, 4) === base.slice(0, 4)
    ? full.slice(5)
    : full;
  return `${word} ${shown}`;
};

const joinDateHint = (item: any) => {
  const others = otherJoinLines(item);
  if (!others.length) return '';
  const picked = shownEmployment(item);
  const used = employmentSourceLabel(picked?.clci_source);
  const date = formatDate(picked?.clci_work_start_date);
  const rest = others
    .map((line) => `${employmentSourceLabel(line.clci_source)} ${formatDate(line.clci_work_start_date)}`)
    .join(', ');
  return `임금에는 ${used} ${date}을 사용합니다. 다른 입사일은 ${rest}입니다.`;
};

const latestCollectAt = (item: any) => {
  let latest = '';
  employmentLines(item).forEach((line) => {
    const stamp = String(line.clci_wdate || line.clci_rdate || '');
    if (stamp > latest) latest = stamp;
  });
  return latest || null;
};

const isWageEmployment = (item: any, line: EmploymentLine) => {
  if (!hasSeveralEmployments(item)) return false;
  const picked = wageEmployment(item);
  if (!picked) return false;
  return picked.clci_source === line.clci_source && Number(picked.clci_idx) === Number(line.clci_idx);
};

const wageEmploymentNote = (item: any) => {
  const picked = wageEmployment(item);
  if (!picked) return '';
  const used = employmentSourceLabel(picked.clci_source);
  const date = formatDate(picked.clci_work_start_date);
  const editing = employmentSourceLabel(item?.clci_source);
  const editsApplied = isWageEmployment(item, {
    clci_source: item?.clci_source,
    clci_idx: item?.clci_idx,
  });
  if (editsApplied) {
    return `임금과 증명서에는 이 ${used} 입사일 ${date}을 사용합니다.`;
  }
  return `임금과 증명서에는 ${used} 입사일 ${date}을 사용합니다. 아래 저장은 ${editing} 기록만 바꿉니다.`;
};

const toDateOnly = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  return String(dateStr).split('T')[0];
};

const leaveDateOf = (row: { clci_work_end_date?: string | null }) => {
  const d = toDateOnly(row.clci_work_end_date);
  if (!d || d === '0000-00-00' || d === '9999-12-31') return '';
  return d;
};

/** 같은 사람의 이전 근무에 퇴사일이 있고, 이 줄은 퇴사일이 없으면 재입사 */
const isEmployeeRehire = (item: {
  clci_name?: string;
  clci_birth_date?: string | null;
  clci_work_start_date?: string | null;
  clci_work_end_date?: string | null;
  clci_source?: string;
  clci_idx?: number;
}) => {
  if (leaveDateOf(item)) return false;
  const name = String(item.clci_name || '').trim().toLowerCase();
  const birth = toDateOnly(item.clci_birth_date);
  const start = toDateOnly(item.clci_work_start_date);
  if (!name || !birth) return false;
  return employeeList.value.some((row) => {
    if (row.clci_source === item.clci_source && row.clci_idx === item.clci_idx) return false;
    if (String(row.clci_name || '').trim().toLowerCase() !== name) return false;
    if (toDateOnly(row.clci_birth_date) !== birth) return false;
    if (!leaveDateOf(row)) return false;
    const rowStart = toDateOnly(row.clci_work_start_date);
    return !start || !rowStart || rowStart <= start;
  });
};

const INVALID_SCHEDULE_CERT_NUMBERS = new Set(['', '9999-12-31']);

const isValidScheduleRecipientId = (approvalNo: string | null | undefined): boolean => {
  const code = (approvalNo || '').trim();
  return code.length > 0 && !INVALID_SCHEDULE_CERT_NUMBERS.has(code);
};

const showBeneficiaryCalendar = ref(false);
const showEmployeeCalendar = ref(false);
const showAllBeneficiarySchedule = ref(false);
const beneficiaryPdfLoading = ref(false);
const employeePdfLoading = ref(false);
const calendarBeneficiary = ref<CalendarBeneficiary | null>(null);
const calendarCaregiver = ref<CalendarCaregiver | null>(null);

const calendarBeneficiaryList = computed<CalendarBeneficiary[]>(() =>
  filteredBeneficiaryList.value
    .filter((item) => isValidScheduleRecipientId(item.clsr_approval_no))
    .map((item) => ({
      patient_code: item.clsr_approval_no.trim(),
      patient_name: item.clsr_recipient_name,
    }))
);

const calendarCaregiverList = computed<CalendarCaregiver[]>(() =>
  filteredEmployeeList.value
    .filter((item) => item.clci_name && toDateOnly(item.clci_birth_date))
    .map((item) => ({
      emp_name: item.clci_name,
      emp_birth: toDateOnly(item.clci_birth_date),
      emp_job: item.clci_job_type || '요양보호사',
    }))
);

const canOpenBeneficiarySchedule = (item: { clsr_approval_no?: string | null }) =>
  isValidScheduleRecipientId(item.clsr_approval_no);

const canOpenEmployeeSchedule = (item: { clci_name?: string; clci_birth_date?: string | null }) =>
  !!(item.clci_name && toDateOnly(item.clci_birth_date));

const openBeneficiarySchedule = (item: {
  clsr_approval_no: string;
  clsr_recipient_name: string;
}) => {
  if (!canOpenBeneficiarySchedule(item)) {
    alert('수급자 인정번호가 등록되어 있어야 일정계획을 조회할 수 있습니다.');
    return;
  }
  calendarBeneficiary.value = {
    patient_code: item.clsr_approval_no.trim(),
    patient_name: item.clsr_recipient_name,
  };
  showBeneficiaryCalendar.value = true;
};

const openBeneficiaryScheduleFromDetail = () => {
  if (!selectedBeneficiary.value) return;
  openBeneficiarySchedule(selectedBeneficiary.value);
};

const openEmployeeSchedule = (item: {
  clci_name: string;
  clci_birth_date: string | null;
  clci_job_type?: string | null;
}) => {
  if (!canOpenEmployeeSchedule(item)) {
    alert('요양보호사 이름과 생년월일이 있어야 일정계획을 조회할 수 있습니다.');
    return;
  }
  calendarCaregiver.value = {
    emp_name: item.clci_name,
    emp_birth: toDateOnly(item.clci_birth_date),
    emp_job: item.clci_job_type || '요양보호사',
  };
  showEmployeeCalendar.value = true;
};

const openEmployeeScheduleFromDetail = () => {
  if (!selectedEmployee.value) return;
  openEmployeeSchedule(selectedEmployee.value);
};

const onOpenRecipientFromAllSchedule = (recipient: CalendarBeneficiary) => {
  showAllBeneficiarySchedule.value = false;
  calendarBeneficiary.value = recipient;
  showBeneficiaryCalendar.value = true;
};

const downloadAllBeneficiaryPdf = async () => {
  if (!memberCode.value) return;
  beneficiaryPdfLoading.value = true;
  try {
    const fetchPdf = (omitBizGubun: boolean) =>
      homeScheduleApi.downloadAllBeneficiariesPdf(
        memberCode.value,
        scheduleYearMonth.value,
        omitBizGubun ? undefined : selectedBizGubun.value || undefined
      );

    let res;
    try {
      res = await fetchPdf(false);
    } catch (error: unknown) {
      const status = (error as any)?.response?.status;
      if (status === 404 && selectedBizGubun.value) {
        res = await fetchPdf(true);
      } else {
        throw error;
      }
    }
    downloadPdfBlob(res.data, `전체수급자_일정표_${scheduleYearMonth.value}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '전체 수급자 PDF 출력에 실패했습니다.');
    alert(`전체 PDF 출력 실패: ${message}`);
  } finally {
    beneficiaryPdfLoading.value = false;
  }
};

const downloadAllCaregiverPdf = async () => {
  if (!memberCode.value) return;
  employeePdfLoading.value = true;
  try {
    const fetchPdf = (omitBizGubun: boolean) =>
      homeScheduleApi.downloadAllCaregiversPdf(
        memberCode.value,
        scheduleYearMonth.value,
        omitBizGubun ? undefined : selectedBizGubun.value || undefined
      );

    let res;
    try {
      res = await fetchPdf(false);
    } catch (error: unknown) {
      const status = (error as any)?.response?.status;
      if (status === 404 && selectedBizGubun.value) {
        res = await fetchPdf(true);
      } else {
        throw error;
      }
    }
    downloadPdfBlob(res.data, `전체요양보호사_일정표_${scheduleYearMonth.value}.pdf`);
  } catch (error: unknown) {
    const message = await getApiErrorMessage(error, '전체 요양보호사 PDF 출력에 실패했습니다.');
    alert(`전체 PDF 출력 실패: ${message}`);
  } finally {
    employeePdfLoading.value = false;
  }
};

const formatDateTime = (dateStr: string | null) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr).replace('T', ' ').slice(0, 16);
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${y}.${mo}.${day} ${h}:${mi}`;
};

const loadAll = async () => {
  await Promise.all([loadEmployeeList(), loadBeneficiaryList()]);
};

watch(selectedBizGubun, () => {
  newEmployeeRows.value.forEach((row) => {
    if (row.clci_job_type && !isEmployeePosition(row.clci_job_type)) {
      row.clci_job_type = defaultPosition.value;
    }
  });
});

watch(memberCode, (code) => {
  if (code) {
    loadAll();
  }
});

watch(
  () => memberData?.value?.m_code,
  (code) => {
    if (code && !route.params.memberCode) loadAll();
  }
);

watch(
  () => route.query.tab,
  (tab) => {
    if (tab === 'beneficiary' || tab === 'employee') {
      activeTab.value = tab;
    }
  },
  { immediate: true }
);

onMounted(async () => {
  const tab = route.query.tab as string;
  if (tab === 'beneficiary' || tab === 'employee') {
    activeTab.value = tab;
  }
  await refreshJobTypes();
  newEmployeeRows.value.forEach((row) => {
    if (!row.clci_job_type) {
      row.clci_job_type = defaultPosition.value;
    }
  });
  if (memberCode.value) {
    loadAll();
  }
});
</script>

<style lang="scss">
@import '@/assets/styles/variables';
@import '@/assets/styles/pages/member-wage-hr-management';
</style>
